export default {
  date: {
    formats: {
      default: '%d/%m/%Y',
      short: '%-d de %B',
      long: '%-d de %B de %Y',
      with_day: '%A, %-d de %B',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
    ],
    abbr_day_names: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    month_names: [
      null,
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ],
    abbr_month_names: [
      null,
      'Ene.',
      'Feb.',
      'Mar.',
      'Abr.',
      'May.',
      'Jun.',
      'Jul.',
      'Ago.',
      'Sep.',
      'Oct.',
      'Nov.',
      'Dic.',
    ],
    order: ['day', 'month', 'year'],
  },
  number: {
    format: {
      separator: ',',
      delimiter: '.',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%n %u',
        unit: '€',
        separator: ',',
        delimiter: '.',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'CAD',
      AUD: 'AUD',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n %',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 1,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Bytes',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'mil',
          million: 'millón',
          billion: 'mil millones',
          trillion: 'billón',
          quadrillion: 'mil billones',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'medio minuto',
      less_than_x_seconds: {
        one: 'menos de 1 segundo',
        other: 'menos de %{count} segundos',
        few: 'menos de %{count} segundos',
        many: 'menos de %{count} segundos',
      },
      x_seconds: {
        one: '1 segundo',
        other: '%{count} segundos',
        few: '%{count} segundos',
        many: '%{count} segundos',
      },
      less_than_x_minutes: {
        one: 'menos de 1 minuto',
        other: 'menos de %{count} minutos',
        few: 'menos de %{count} minutos',
        many: 'menos de %{count} minutos',
      },
      x_minutes: {
        one: '1 minuto',
        other: '%{count} minutos',
        few: '%{count} minutos',
        many: '%{count} minutos',
      },
      about_x_hours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de %{count} horas',
        few: 'casi %{count} horas',
        many: 'casi %{count} horas',
      },
      x_days: {
        one: '1 día',
        other: '%{count} días',
        few: '%{count} días',
        many: '%{count} días',
      },
      about_x_months: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de %{count} meses',
        few: 'casi %{count} meses',
        many: 'casi %{count} meses',
      },
      x_months: {
        one: '1 mes',
        other: '%{count} meses',
        few: '%{count} meses',
        many: '%{count} meses',
      },
      about_x_years: {
        one: 'alrededor de 1 año',
        other: 'alrededor de %{count} años',
        few: 'casi %{count} años',
        many: 'casi %{count} años',
      },
      over_x_years: {
        one: 'más de 1 año',
        other: 'más de %{count} años',
        few: 'más de %{count} años',
        many: 'más de %{count} años',
      },
      almost_x_years: {
        one: 'casi 1 año',
        other: 'casi %{count} años',
        few: 'casi unos %{count} años',
        many: 'casi unos %{count} años',
      },
      x_years: {
        one: '1 año',
        other: '%{count} años',
      },
      x_weeks: {
        one: '1 semana',
        other: '%{count} semanas',
        few: '%{count} semanas',
        many: '%{count} semanas',
      },
      x_hours: {
        one: '1 hora',
        other: '%{count} horas',
      },
    },
    prompts: {
      year: 'Año',
      month: 'Mes',
      day: 'Día',
      hour: 'Hora',
      minute: 'Minutos',
      second: 'Segundos',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
  },
  page: {
    plus: {
      button: {
        text: 'Hazte con Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Hasta 5 imágenes distintas',
        best_2: 'JPEG o PNG',
        best_3: 'Hasta %{size}',
        best_4: '%{resolution} o más píxeles',
        best_5: 'GIFs y vídeos no se pueden utilizar (perdón)',
        best_title: 'Lo más importante:',
        text: 'Ponte a ti mismo o a tu marca en primera fila con hasta cinco imágenes o vídeos de fondo que se van alternando automáticamente:',
        best_five: '%{videoResolution} píxeles para los vídeos',
        best_four: '%{resolution} píxeles para las imágenes',
        best_one: 'Hasta 5 vídeos o imágenes',
        best_six:
          'Los fondos de imagen son intercambiados cada %{rotationInterval} segundos; los vídeos más largos de %{rotationInterval} no se mostrarán al completo',
        best_three: '%{size} máx. por vídeo/imagen',
        best_two: 'JPEG, PNG o MP4',
        notice:
          "¡Tatatachán! ¡Ahora puedes utilizar vídeos como fondos! <a href='/profile'>Convierte tu fondo en vídeo ahora mismo</a>.",
      },
      upsell: {
        benefit_one_alt: 'Consigue tu propia página de WeTransfer',
        heading_alt: 'Entrega tu trabajo con estilo',
        benefit_one: 'Consigue tu propio dominio WeTransfer',
        benefit_three: 'Diseña tus emails de transferencia',
        benefit_two:
          'Muestra tus fondos de pantalla cuando la gente se descargue tus archivos',
        button: {
          action: 'Cuéntame más',
        },
        heading: 'Promociona tu marca con WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Envía los mejores archivos.</strong> Causa una gran impresión cada vez que la gente descargue tus archivos.<br /> <strong>Recibe archivos con facilidad.</strong> Cualquiera puede subir archivos a tu espacio como parte de tu plan.',
        protip: {
          text: '<strong>Consejo del experto:</strong> ¿Quieres solicitar una transferencia a alguien? Comparte un enlace especial para completar previamente su descripción.',
          link: 'Más información',
        },
      },
      pagename: 'Configuración del perfil',
      'onboarding-step-two':
        "Presenta tus archivos con estilo, personaliza tu perfil de WeTransfer y admira tu nueva apariencia en <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Fondos de pantalla de los correos electrónicos',
      sent_you_files: 'te envió algunos archivos',
      email_background_instruction_with_spec:
        'Destaca tus mensajes de transferencia añadiéndoles una imagen de fondo.\nPara lograr los mejores resultados, sube una imagen no mayor de %{resolution} píxeles (si la imagen supera ese tamaño, tendremos que recortarla). El tamaño máximo de archivo es de %{size}.',
      receiving: 'Email de perfil',
      choose_wallpapers: 'Fondos',
      'step-one-banner':
        'Para empezar, elige una URL para tu página de WeTransfer. Siempre puedes cambiarla más adelante.',
      description: {
        pro: 'Tu página de WeTransfer te permite causar una impresión fantástica cada vez que alguien descargue tus archivos. También es el lugar en el que cualquiera puede enviarte transferencias de 200 GB como parte de tu plan WeTransfer Pro.',
        premium:
          'Tu página de WeTransfer te permite causar una impresión fantástica cada vez que alguien descargue tus archivos. También es el lugar en el que cualquiera puede enviarte transferencias sin límite de tamaño de archivo, como parte de tu plan WeTransfer Premium.',
      },
      'instructions-1':
        'Cambia tu nombre y tu URL tantas veces como necesites.',
      'instructions-2':
        'Una vez que hayas elegido una nueva URL, tu página se actualizará de inmediato.',
      title: 'Edita tu página',
      profile_url: 'URL de perfil',
    },
    payment: {
      never_actived_retry:
        'Tu cuenta aún no está activa. Completa tu registro para empezar con <a href="/payment/retry">%{planName}</a>',
      pagename: 'Plan y pago',
      autorenew_heading: 'Datos de pago',
      autorenew_notice:
        'Tu suscripción %{planName} de %{deal} se renovará automáticamente el %{autorenewal_attempt}.',
      will_expire_notice:
        "Tu suscripción a Pro <span class='payment__notice'>caducará en %{daysBetween} días</span>. Renueva tu cuenta ahora o configura la renovación automática.",
      never_actived_notice:
        'Tu cuenta aún no está activa. <a href="/payment/retry">Completa tu registro para comenzar a usar Pro.</a>',
      manual_renewal_expiry_notice: 'Tu cuenta Pro caducará el %{expiry}.',
      to_checkout: 'Pasar por caja',
      updating: 'Actualizando...',
      yes_disable: 'Sí, adelante',
      review_billing_link: '¿Quieres actualizar tu forma de pago?',
      autorenew_failed:
        "Tu suscripción a Pro de %{deal}/%{period} caducará <span class='payment__notice'><strong>en %{daysBetween} días</strong>. No hemos podido renovar tu cuenta, por favor, renuévala manualmente antes del <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        '¿Estás seguro de que deseas detener las renovaciones automáticas?',
      disable_autorenewal: 'Detén las renovaciones automáticas',
      enable_autorenewal: 'Renovación automática',
      renew_now: 'Renovar ahora',
      subscription_expired: 'Tu suscripción Pro ha finalizado.',
      cancel_heading: '¿Es hora de seguir?',
      cancel_info:
        'Lo comprendemos, las cosas van como van. Una vez hayas cancelado tu suscripción, guardaremos tus archivos durante 30 días (no debajo de nuestra almohada, claro está), por si acaso. Podrás reactivar tu suscripción en cualquier momento.',
      cancel_info_subscription:
        'Lo comprendemos, las cosas van como van. Una vez hayas cancelado tu suscripción, podrás seguir usando tu cuenta Pro hasta el %{subscriptionExpiryDate}. Después de ese plazo, guardaremos tus archivos 30 días más (no debajo de nuestra almohada, claro está), por si acaso. Podrás reactivar tu suscripción en cualquier momento.',
      cancel_now: 'Cancelar la subscripción',
      cancelling: 'Cancelando...',
      confirm_cancel_subscription:
        '¿Seguro que quieres cancelar tu suscripción?',
      confirm_reactivate_subscription:
        '¡Excelente decisión! Solo te queda un clic más para reactivar tu forma de pago',
      manual_renewal_in_future_notice:
        'Tu suscripción Pro de %{deal}/%{period} caducará en %{daysBetween} días. Podrás renovar manualmente tu suscripción el %{manual_renewal_available_at}, o bien activar ahora la renovación automática.',
      reactivate_heading: 'Comencemos de nuevo.',
      reactivate_content_top_pro:
        'Puedes reactivar tu suscripción a %{planName} y será como si nunca la hubieses cancelado. O puedes elegir actualizar a WeTransfer Premium:',
      reactivate_content_top_premium:
        'Puedes reactivar tu suscripción a %{planName} y será como si nunca la hubieses cancelado.',
      reactivate_content_bottom_pro:
        'Si actualizas a Premium, se te cobrará %{upfront_payment} y podrás empezar a usar WeTransfer Premium de inmediato. Tu nueva suscripción de %{recurring_payment}/%{interval} se renovará en %{recurring_date}.',
      reactivate_pro: 'Reactivar Pro',
      reactivate_premium: 'Reactivar Premium',
      reactivate_upgrade_to_premium: 'Actualizar a Premium',
      reactivating: 'Reactivando...',
      subscription_cancelled:
        'Tu suscripción ha sido cancelada y se desactivará automáticamente en %{daysBetween} días.',
      subscription_reactivate_expired_notice:
        'Tu cuenta Pro ha sido cancelada.',
      subscription_reactivate_notice_pro:
        'Tu suscripción a %{planName} se ha cancelado y finalizará en %{daysBetween} días.\n',
      subscription_reactivate_notice_premium:
        'Tu suscripción a %{planName} se ha cancelado y finalizará en %{daysBetween} días.\n¿Has cambiado de idea? No te preocupes, es fácil volver a poner las cosas en marcha.',
      subscription_reactivate_notice_trial_before:
        'Tu suscripción a %{planName} se ha cancelado y finalizará en %{daysBetween} días.\nPuedes seguir disfrutando de tu prueba de WeTransfer Premium hasta que finalice tu suscripción.',
      subscription_reactivate_notice_trial_after:
        'Tu suscripción a %{planName} se ha cancelado y finalizará en %{daysBetween} días.\nPuedes seguir disfrutando de tu prueba de WeTransfer Premium hasta %{trialExpiryDate}.',
      update_method_link: 'Actualizar datos de pago',
      autorenew_notice_teams:
        'Tu suscripción %{planName} de %{deal} será renovada automáticamente para tu equipo de %{number_of_members} miembros el %{autorenewal_attempt}.',
      cancellation_cta: 'Cancelar suscripción',
      cancellation_heading:
        '¿Ya no te hace falta todo lo que te ofrece %{planName}?',
      cancellation_heading_trial: 'Cancelar la suscripción',
      cancellation_text:
        'Si cancelas tu suscripción, podrás seguir aprovechando todo lo que te ofrece Pro hasta el %{subscriptionExpiryDate}. Después, tu cuenta WeTransfer Pro se convertirá en una cuenta gratuita y tus transferencias caducarán después de 28 días.',
      cancellation_text_item_1: 'Enviar hasta %{transfer_limit}',
      cancellation_text_item_2: 'Proteger tus transferencias con contraseña',
      cancellation_text_item_3:
        'Gestionar y guardar %{storage_limit} en transferencias',
      cancellation_text_item_4:
        'Utilizar una URL personal y página personalizada Pro',
      cancellation_text_item_heading:
        'Una cuenta gratuita sólo te permite enviar %{free_size_limit} por transferencia. Dejarás de poder:',
      cancellation_text_new:
        'Si cancelas tu suscripción ahora, podrás usar %{planName} hasta el %{subscriptionExpiryDate}. Después de esa fecha, convertiremos revertiremos tu cuenta al plan gratuito.<br /><br />Ojo, cuando finalice tu suscripción, tus transferencias existentes caducarán en un máximo de 28 días.',
      cancellation_text_teams:
        'Si cancelas tu suscripción ahora, tú y tu equipo podréis usar %{planName} hasta el %{subscriptionExpiryDate}.<br /><br />Una vez hecho, tú y los miembros del equipo no podréis enviar archivos, crear presentaciones ni hacer boards juntos. Tu cuenta pasará al plan gratuito y solo podrás iniciar sesión en tu cuenta individual de WeTransfer.Ojo, cuando finalice tu suscripción, tus transferencias existentes caducarán en un máximo de 28 días.',
      premium_trial: {
        feature_list_item_1: 'Transferencias sin límite de tamaño',
      },
      premium_upgrade: {
        cta: 'Cambiar a Premium',
        description:
          'Se te cobrará %{upfront_payment} y podrás empezar a usar WeTransfer Premium al instante. Tu nueva suscripción de %{recurring_payment} %{interval} se renovará el %{recurring_date}.',
        feature_list_item_1: 'Envía transferencias sin límites de tamaño',
        feature_list_item_2: 'Almacenamiento ilimitado',
        feature_list_item_3: 'Portales y revisiones ilimitados',
        feature_list_item_4: '%{storageLimit} de almacenamiento',
        heading: '¿Quieres mejorar tu plan?',
      },
      unpaid_invoices: {
        heading: 'Tienes facturas por pagar',
        item: {
          issued_on: 'Emitida el',
          pay_invoice: 'Pagar factura',
          pending_invoice: 'Pendiente...',
        },
        subheading:
          'Parece que ha habido problemas con tus pagos anteriores. Por favor, paga las facturas pendientes o tu suscripción a Pro podría ser cancelada.',
        subheading_2:
          'Si tienes facturas pendientes, vuelve a intentarlo dentro de un par de días y ya podrás comenzar una vez que el pago se haya realizado correctamente.',
      },
      upgrade_cta: 'Ampliar',
      app_subscription_banner: {
        title: 'Te has suscrito desde %{app_name}',
        content:
          'Para ver o administrar tu suscripción, inicia sesión en tu cuenta de %{app_name} desde tu teléfono u ordenador.',
        go_to: 'Ir a',
        learn_more: 'Leer más',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Cancelar suscripción',
      cancellation_disclaimer:
        '*Ojo, después de que tu cuenta haya sido modificada, tus transferencias existentes caducarán en un máximo de 28 días.',
      'current-plan': 'Plan actual',
      'free-forever': 'Gratuito para siempre',
      'free-usp-1': 'Enviar hasta 2 GB',
      'free-usp-2': 'Sin almacenamiento',
      'free-usp-3': 'Las transferencias caducan en 7 días*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Si decides cancelar tu suscripción ahora, podrás seguir utilizando WeTransfer Pro hasta <b>%{expiration_date}</b>. Después, tu cuenta se convertirá en una cuenta gratuita de WeTransfer, que no está nada mal tampoco.',
      pagename: '¿Ya no te hace falta todo lo que te ofrece Pro?',
      'pro-usp-1': 'Enviar y recibir hasta %{transfer_limit}',
      'pro-usp-2': 'Almacenamiento de 1 TB',
      'pro-usp-3': 'Elegir una fecha de caducidad para tus transferencias',
      'pro-usp-4':
        '<p>Tu <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">página Pro</a> personal</p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Acceder a Paste® Pro y Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Tu suscripción ha sido cancelada y tu cuenta se convertirá en una cuenta WeTransfer gratuita después del <b> %{ends_at}.</b></p>\n<p>Cuéntanos por qué has decidido dejarnos, para que podamos seguir mejorando WeTransfer con tus deseos en mente.</p>',
      reason_header: 'Nos da pena que te vayas',
      cancel: 'Volver',
      info: 'Cuéntanos por qué has decidido dejarnos, para que podamos seguir mejorando WeTransfer Pro con tus deseos en mente.',
      pagename: 'Antes de que nos dejes',
      yes_disable: 'Sí, adelante',
    },
    payment_failed: {
      selected_product: 'Un %{duration} de %{planTier}',
      change: 'Actualizar',
      complete_order: 'Finaliza tu pedido',
      description: 'Revisa tus datos y finaliza tu pedido',
      description_error:
        'Algo salió mal, revisa tus datos y continúa con el proceso de compra',
      description_refused:
        'No hemos podido procesar tu pago, revisa tus datos de pago e inténtalo de nuevo',
      discount: 'Descuento',
      product_description: 'Un %{duration} de WeTransfer Pro',
      title: '¡Ya casi estás!',
      total: 'Total',
      vat: 'IVA',
      your_details: 'Tus datos',
      your_order: 'Tu pedido',
      title_error: 'Hmmm... algo parece haber salido mal',
      title_refused: 'Hmmm... algo parece haber salido mal',
      payment_status_message:
        'Tu pago se ha realizado correctamente, pero se ha producido un error y no hemos podido actualizar tu plan automáticamente. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Contacta con nuestro equipo de asistencia</a>',
    },
    payment_methods: {
      billed_now: 'Facturado ahora',
      info_content: {
        cancel_bullet:
          'No te preocupes, puedes encontrar la opción de cancelar en Configuración de tu cuenta > Pago.',
        initial_payment_bullet:
          'Tras el pago inicial, se te cobrará %{price} %{interval} (salvo que decidas cancelar tu suscripción, pero tú no harías algo así, ¿verdad? ¡¿Verdad?!)',
        update_payment_bullet:
          'Siempre puedes actualizar los datos de pago y/o la información de facturación antes de que venza tu próximo pago.',
        month:
          '- Después del primer pago, se efectuarán automáticamente pagos de %{price} cada mes (salvo que decidas cancelar tu suscripción Pro, pero eso no va a pasar, ¿verdad?)\n- No te preocupes, puedes cancelar tu suscripción desde Cuenta > Información de facturación.\n- Siempre puedes actualizar tu forma de pago o los datos de tu empresa antes de que se efectúe el siguiente pago.',
        year: '- Después del primer pago, se efectuarán automáticamente pagos de %{price} una vez al año hasta que decidas cancelar tu suscripción a WeTransfer Pro (cosa que no harías jamás, ¿verdad que no?). \n- No te preocupes, podrás cancelar tu subscripción a través de Cuenta > Información de facturación. \n- Siempre podrás actualizar tu forma de pago y/o datos de empresa antes de que se efectúe el siguiente pago.',
      },
      payment_cta: 'Completar pago',
      payment_term: {
        monthly: 'al mes',
        yearly: 'al año',
      },
      payment_title: 'Pago',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'al mes',
        year: 'al año',
      },
      subtotal: 'Subtotal',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Tu método de pago',
      bancontact: 'Bancontact',
      card: 'Tarjeta de crédito',
      card_cvc: 'CVC',
      card_expiration: 'MM / AA',
      card_name: 'Nombre en la tarjeta',
      card_number: 'Número de tarjeta',
      complete_payment: 'Finaliza tu pago',
      creditcard: 'Tarjeta de crédito',
      discount: 'Descuento',
      do_not_refresh: 'No actualices ni cierres la página',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL es una forma de pago online holandesa, mediante la cual el usuario puede utilizar su propio banco para efectuar el pago.',
      info: 'Actualizar forma de pago',
      payment_in_progress: 'Tu pago está siendo procesado...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/mes',
        year: '/año',
      },
      select_bank: 'Selecciona tu banco',
      select_country: 'Seleccionar país',
      sofort: 'SOFORT',
      tax: 'IVA',
      title: 'Elige tu forma de pago',
      total: 'Total',
    },
    projects: {
      actions: {
        go_back: 'Todos los proyectos',
        discard: 'Descartar cambios',
        edit: 'Editar',
        remove_transfer:
          '¿Eliminar esta transferencia? Los archivos se eliminarán de este proyecto y de las transferencias enviadas.',
        save: 'Guardar',
        share: 'Compartir',
      },
      transfer_actions: {
        download: 'Descargar',
      },
      added_at: 'a las %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Copiar enlace',
        link_copied: 'Enlace copiado en el portapapeles',
        content_label: 'Copiar enlace a este proyecto',
        list_item_1: 'Descargar y ver acceso solo',
        list_item_2: 'El enlace permanece igual, para siempre',
        title: 'Compartir proyecto',
      },
      content: {
        empty_state:
          'Tu proyecto está actualmente vacío. Comienza añadiendo algunos archivos para iniciar el plazo de tu proyecto.',
      },
      logo_title: 'Volver a wetransfer.com',
      logo_tooltip_caption: 'Volver a WeTransfer',
      timestamp: 'Hace %{timeAgo}',
      chat: {
        owner_button_label: 'Oye... habla con nosotros',
        owner_offline_greeting:
          'En estos momentos no estamos en línea, pero indícanos qué problemas tienes y nos pondremos en contacto contigo en el plazo de un día laborable.',
        owner_online_greeting:
          'Dinos qué problemas tienes y nos pondremos en contacto contigo lo antes posible.',
        receiver_button_label: '¿Alguna pregunta? Estamos aquí para ayudar',
        receiver_offline_greeting:
          'Dinos qué problemas tienes y nos pondremos en contacto contigo lo antes posible.',
        receiver_online_greeting:
          'Dinos qué problemas tienes y nos pondremos en contacto contigo lo antes posible.',
      },
      created_by: 'Creado por %{user}',
      created_by_fallback: 'Creado',
      deliverable_clipboard_modal: {
        content_label: 'Copiar enlace a este entregable',
        info: 'La gente también podrá ver tu proyecto',
        title: 'Compartir el entregable',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Este no es el proyecto que buscas...',
        limit:
          'Tu potencial es infinito, pero has alcanzado tu límite de caracteres',
        required:
          'Ya sabes lo que toca. No puedes omitir el paso de rellenar esto',
      },
      event: {
        project_created_byline:
          'Añade archivos para mostrar en qué estás trabajando.',
        project_created_title: 'Inicio del proyecto',
      },
      file_count: {
        one: '%{count} archivo',
        other: '%{count} archivos',
      },
      just_now: 'ahora mismo',
      labels: {
        description: 'Descripción',
        name: 'Nombre',
        new_name: 'Nombra tu proyecto',
      },
      logo: {
        cta: 'Añade un logotipo',
        errors: {
          dimensions:
            'Tu logotipo es más pequeño que 220 x 220 px. Prueba con una imagen más grande',
          general: 'Vaya, algo salió mal. Inténtalo otra vez',
          size: 'Tu logotipo supera los 5 MB. Prueba con un archivo más pequeño',
          type: 'Tu logotipo no es un archivo JPEG, GIF o PNG. Prueba con otra imagen',
        },
        instructions:
          'Tu logotipo puede ser de hasta 5 MB. Los JPEG y los GIF están bien, pero los PNG con fondo transparente son los que mejor quedan',
        'instructions-title': 'Exhibe tu marca',
      },
      name_modal: {
        content_label: 'Nombra o renombra tu proyecto',
        input_placeholder_0: 'Sin duda un león de Cannes',
        input_placeholder_1: 'Una cura para el resfriado común',
        input_placeholder_2: 'El crimen perfecto',
        input_placeholder_3: 'Escribo canciones, no títulos',
        input_placeholder_4: 'Idea galardonada',
        input_placeholder_5: 'Campaña de marca totalmente nueva',
        input_placeholder_6: 'Dominio mundial',
        save: 'Guardar',
        text: 'Describe en qué estás trabajando.',
        title: 'Nombra tu proyecto',
      },
      new_project_label: 'Iniciar nuevo proyecto',
      noticebar: {
        'button-cancel': 'Cancelar',
        'button-clear-all-files': 'Eliminar todo',
        'button-close': 'Cerrar',
        'button-delete': 'Eliminar',
        'button-no': 'No',
        'button-share': 'Compartir',
        'button-yes': 'Sí',
        'confirm-cancel': '¿Quieres cancelar esta transferencia?',
        'confirm-clear-files-deliverable':
          '¿Eliminar todos los archivos de <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          '¡Todo listo! Informa a todos de que has añadido más archivos.',
        'confirm-delete-deliverable':
          '¿Eliminar <strong><u>%{deliverableName}</u></strong> y cualquier archivo que hayas subido?',
        'confirm-first-complete':
          '¡Todo listo! Comparte este proyecto para descargar tus archivos.',
        deliverable_not_found_error:
          'Hmm, parece que esa entrega ha sido eliminada',
        general_error: 'Vaya, algo ha salido mal. Vuelve a intentarlo.',
      },
      'onboarding-promise': {
        description:
          'Describe todo el trabajo que entregarás para un proyecto y optimiza la forma en la que lo compartes. Crea una lista de entregables y, a continuación, añade archivos a medida que progresas. Se acabaron los enlaces de descarga diferentes.',
        title: 'Comienza por el buen camino para seguir por el buen camino',
      },
      onboarding: {
        banner:
          '¡Aviso! Eres uno de los pocos elegidos con acceso a Proyectos mientras aún se está construyendo (y mejorando). Es posible que nos pongamos en contacto contigo para escuchar tus comentarios.',
      },
      pagename: 'Proyectos',
      placeholders: {
        description: 'Dale a tu proyecto una breve descripción',
        loading: 'Cargando...',
      },
      project: {
        notification: {
          name_saved: '¡Nombre guardado! Tu proyecto suena a ganador.',
        },
      },
      share_button_label: 'Compartir',
      unnamed_project_title: 'Proyecto sin nombre',
      watch_video: 'Ver vídeo',
    },
    transfer: {
      display_name_fallback: 'Transferencia sin nombre',
      does_not_expire: 'sin <u>fecha de caducidad</u>',
      expires_in: 'Caducará en <span>%{time}</span>',
      downloaded_at: 'Descargado el %{date} a las %{time}',
      not_downloaded: 'Aún no se ha descargado',
      email_bounced:
        'Vaya, la dirección de correo electrónico a la que lo enviaste no funcionó',
      count_files: {
        one: '%{count} archivo',
        other: '%{count} archivos',
      },
      sent_datetime: 'Enviado el %{date} a las %{time}',
      never_expires: 'Sin fecha de caducidad',
      and_more: 'Y %{count} más',
      read_more: 'más',
      copy_link: 'copiar enlace',
      message: 'Mensaje',
      total_downloads: 'Descargas totales',
      sent_to_recipients: {
        one: 'Enviado a %{count} persona',
        other: 'Enviado a %{count} personas',
      },
      no_transfers: 'Todas las transferencias que hagas aparecerán aquí',
      add_first_description:
        'Comprueba el estado de la descarga, edítala, reenvíala o bórrala.',
      mobile: {
        download: 'Descargar todos los archivos',
        remove: 'Eliminar transferencia',
      },
      delete_datetime: 'Archivos eliminados el %{date} a las %{time}',
      detail: {
        plus_download_stats:
          'Consigue Pro para estar al tanto de las veces que tus transferencias han sido descargadas.',
        plus_password_expiration:
          'Consigue Pro para configurar contraseñas y fechas de caducidad para tus transferencias.',
        plus_transfer_actions:
          'Consigue Pro para administrar tus transferencias y eliminarlas cuando quieras.',
        title: 'Datos de tu transferencia',
      },
      download_status_email: '%{count} de %{total} personas',
      download_status_email_text: {
        zero: 'Aún no se ha descargado',
        one: '%{count} de %{total} personas',
        other: '%{count} de %{total} personas',
      },
      download_status_link: {
        one: 'una vez',
        other: '%{count} veces',
      },
      download_status_link_text: {
        zero: 'Aún no se ha descargado',
        one: '1 vez',
        other: '%{count} veces',
      },
      sent_moment: 'Enviado %{moment}',
      total_downloads_tooltip:
        '¿Diferente a lo que esperabas? Hemos hecho un pequeño cambio recientemente. Este número muestra solo las descargas completadas.',
      display_name: {
        label: 'Título',
        label_mobile: 'Añade un título que describe tu transferencia',
      },
      download_status_received_text: {
        zero: 'Aún no ha sido descargado',
        one: 'Descargado',
        other: 'Descargado',
      },
      edit_display_name: {
        cancel: 'Cancelar',
        save: 'Guardar',
        title: 'Título',
      },
      received_datetime: 'Recibido el %{date} a las %{time}',
      received_from: 'Recibido de',
      received_moment: 'Recibido %{moment}',
      teams: {
        received_by: 'Recibido por',
        self: 'mi',
        sent_by: 'Enviado por',
      },
      title: 'Título',
      set_password: {
        added: 'Agregada',
        change: 'Cambiar',
        remove: 'Eliminar',
        description:
          'Establece una contraseña para controlar quién tiene acceso a esta transferencia.',
        remove_warning:
          '¿Eliminar la protección con contraseña de esta transferencia?',
        yes_remove: 'Sí, eliminar',
      },
      set_expiration: {
        description:
          'Establece una fecha de caducidad para limitar el acceso a esta transferencia.',
        label: 'Caducará el',
      },
      anon_upsell_no_account:
        'Para editar o realizar un seguimiento de las descargas de esta transferencia antes de que caduque, <a href="%{href}">regístrate</a> de forma gratuita.',
      anon_upsell_found_account:
        'Para editar o realizar un seguimiento de las descargas de esta transferencia antes de que caduque, <a href="%{href}">inicia sesión</a>.',
      anon_upsell_no_account_with_button:
        'Puedes editar esta transferencia antes de que caduque creando una cuenta.',
      create_free_account: 'Crear cuenta gratuita',
    },
    transfers: {
      space_used_unlimited: ' %{space} de almacenamiento utilizados',
      pagename: 'Transferencias',
      search: 'buscar por nombre de archivo',
      search_results: {
        one: '%{count} resultado de búsqueda',
        other: '%{count} resultados de búsqueda',
        none: 'No hay resultados',
        retry:
          'No hemos encontrado transferencias que coincidan con tu búsqueda. Inténtalo de nuevo.',
      },
      space_used: '%{space} de %{totalSpace} utilizados',
      selected_text: {
        one: '%{count} transferencia seleccionada (%{size})',
        other: '%{count} transferencias seleccionadas (%{size})',
      },
      last_7_days: 'Enviado en los últimos 7 días',
      over_7_days: 'Enviado hace más de 7 días',
      sort_on: 'Ordenar por:',
      size: 'Tamaño',
      name: 'Nombre',
      date: 'Fecha',
      delete: 'Eliminar',
      download: 'Descargar',
      forward: 'Reenviar',
      remove: 'Eliminar',
      select: 'Seleccionar',
      copy_link: 'Copiar enlace',
      sent_time_ago: 'Enviado hace %{timeAgo}',
      files: {
        one: '%{count} archivo',
        other: '%{count} archivos',
      },
      confirm_transfer_delete:
        'Espera, ¿estás seguro de que quieres eliminar esta transferencia?',
      confirm_forward:
        'Si reenvías esto sustituirá tu transferencia actual, ¿quieres continuar?',
      confirm_expired_transfer_delete:
        'Esta acción eliminará para siempre los archivos y la información de la transferencia. ¿Continuar?',
      deleting_now: 'Vamos a eliminarlas',
      deselect_all_transfers: {
        one: 'Anular selección',
        other: 'Anular la selección de las %{count} transferencias',
      },
      downloads: 'Descargas',
      expiration: 'Fecha de caducidad',
      expiration_next: 'Caduca en %{days}',
      expiration_no_date: 'Sin fecha de caducidad',
      expiration_not_soon: 'No caduca en breve',
      include_archived_switch_label:
        'Incluir datos de transferencias eliminadas',
      include_archived_switch_tooltip:
        'Estos archivos no cuentan de cara a tu límite de almacenamiento',
      notify_completed:
        'Transferencia finalizada. Puedes cerrar este panel, o no, si lo prefieres.',
      preview: 'Previsualizar',
      remove_permanently: 'Eliminar información para siempre',
      search_placeholder: 'Buscar por nombre de archivo o dirección de e-mail',
      select_all_transfers: {
        one: 'Selecionar todas las transferencias',
        other: 'Selecionar las %{count} transferencias',
      },
      space_left: '%{space} de %{totalSpace} restantes',
      teams_tip: {
        subtitle:
          'Esta página muestra tu propio historial de transferencias. Por si te lo estás preguntando: tus compañeros de equipo solo pueden ver sus propias transferencias.',
        title: 'Tu equipo Pro está creciendo…',
      },
      title: 'Transferencias enviadas',
      view_details: 'Ver detalles',
      edit_display_name: 'Editar título',
      received_time_ago: 'Recibido hace %{timeAgo}',
      search_title_placeholder: 'Busca títulos, nombres de archivo o emails',
      see_all: 'Ver todos (%{count})',
      sender: 'Remitente',
      sort_by_title: 'Título',
    },
    accountinfo: {
      pagename: 'Información de la cuenta',
      signed_in_as: 'Conectado como %{name}',
      sign_out: 'Salir',
      paid_on: 'Facturado el',
      no_invoices:
        'Aquí se mostrarán tus recibos, pero parece que por ahora no tienes ninguno. ¡Estás de suerte!',
      subscription_info:
        'Tu suscripción Pro de %{deal} se renovará automáticamente el %{autorenewal_attempt}.',
      payment_success: {
        monthly:
          '¡Genial! Ya puedes disfrutar de WeTransfer Pro durante todo un mes',
        monthly_renewal:
          '¡Genial! Ya puedes disfrutar de WeTransfer Pro durante todo un mes más',
        yearly:
          '¡Genial! Ya puedes disfrutar de WeTransfer Pro durante todo un año',
        yearly_renewal:
          '¡Genial! Ya puedes disfrutar de WeTransfer Pro durante todo un año más',
      },
    },
    changepassword: {
      pagename: 'Cambiar contraseña',
    },
    invoices: {
      pagename: 'Recibos',
    },
    reviewbilling: {
      pagename: 'Confirma tus datos de pago',
      information:
        'Para cambiar tu método de pago, necesitaremos renovar tu suscripción al mismo tiempo',
      information_payment:
        'Se te cobrará %{deal} por el próximo %{period} de Pro; tu suscripción estará activa hasta el %{expiry}',
    },
    renewbilling: {
      pagename: 'Revisa la información y renueva tu suscripción',
    },
    link_downloads_unsubscribe: {
      body: 'Puedes darte de baja de las notificaciones sobre descargas efectuadas mediante enlace. Esta información seguirá disponible en tu resumen de envíos.',
      cta: 'Abrir mi resumen de transferencias',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Seleccionar de la galería',
        },
        next_button: 'Ya está todo listo',
        description:
          'Elige que imagen quieres usar como fondo de pantalla y decide la apariencia que tendrán tus páginas de perfil y descarga. Si lo deseas puedes cargar tu propio diseño o usar cualquiera de los que te proponemos.',
      },
      upload_wallpaper: {
        add_text: 'Subir una imagen',
        add_description:
          'Para lograr los mejores resultados, sube una imagen que mida al menos 2560 x 1600 píxeles. El tamaño máximo del archivo deberá ser de 3 MB.',
        upload_text: 'Sube una imagen o vídeo',
      },
      preview: {
        wallpaper_credits_prefix: 'Fondo de pantalla creado por',
      },
      1: {
        description:
          '&quot;Personaliza lo que los usuarios ven cada vez que les envías archivos. Y, con tu propia página de WeTransfer, cualquiera puede enviarte %{transfer_limit} transferencias: solo tienes que darles tu URL. Tu dirección de correo electrónico aparecerá en la página para que la gente pueda confiar en que te enviarán a ti sus archivos.<br /><br /> \n En primer lugar, elige tu URL.&quot;',
        next: 'Siguiente',
        skip: 'Saltar',
        warning:
          '<strong>Ojo...</strong> solo podrás definirlo una vez (tómate el tiempo que necesites)',
        'blurb-1':
          'Crea tu propia página de WeTransfer para que tenga un aspecto profesional cada vez que alguien descargue tus archivos y que sea (incluso) más fácil para cualquier persona enviarte transferencias.',
        'blurb-2': 'En primer lugar, elige tu URL.',
        welcome: 'Impresiona con tu página WeTransfer personalizada',
        information:
          'No te preocupes, siempre puedes cambiar esto más adelante en <strong>Branding</strong>.',
        description_unlimited:
          'Personaliza lo que ven los demás cuando les envías archivos. Con tu propia página de WeTransfer, cualquiera podrá enviarte transferencias de cualquier tamaño; solo tienes que darles tu URL. Tu dirección de email se mostrará en la página para que estén seguros de que eres tú quien recibe sus archivos.<br /><br /> \nPrimero, elige tu URL.',
      },
      2: {
        description:
          'Puedes elegir hasta 5 fondos diferentes para tu perfil.\n\nPonte a ti mismo o a tu marca en primera fila y envía tus archivos con tu propio estilo.',
        pick: 'Elige uno de nuestra galería',
        title: 'Crea impresión con cada transferencia',
        upload: 'Sube tu propio fondo',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> está listo. Ya puedes añadir este enlace a tu sitio web para que te envíen %{transfer_limit} transferencias. Bueno, y también puedes mandar cosas tú.',
        done: 'Finalizado',
        title: '¡Vaya perfil más majo!',
        description_unlimited:
          '<strong>%{customLink}</strong> está listo. Ya puedes añadir este enlace a tu sitio web para que te envíen transferencias de cualquier tamaño. Bueno, y también puedes mandar cosas tú.',
      },
    },
    contact: {
      add_contact: 'Añadir contacto',
      add_first_description:
        'Guardaremos también las direcciones de correo electrónico a las que envías archivos aquí',
      add_to_transfer: 'Añadir a la transferencia',
      remove_from_transfer: 'Eliminar de la transferencia',
      confirm_delete: {
        one: '¿Estás seguro de querer eliminar este contacto?',
        other: '¿Estás seguro de querer eliminar estos %{count} contactos?',
      },
      contact_count: {
        one: '%{count} contacto',
        other: '%{count} contactos',
      },
      edit: 'Editar',
      mobile: {
        add: 'Añadir contacto',
      },
      no_contacts: '¡Añade tu primer contacto!',
      pagename: 'Contactos',
      remove: 'Eliminar',
      search_count: {
        one: '%{count} resultado de búsqueda',
        other: '%{count} resultados de búsqueda',
      },
      search_placeholder: 'buscar por correo electrónico, nombre o empresa',
      select: 'Seleccionar',
      selected_text: {
        one: '%{count} contacto seleccionado',
        other: '%{count} contactos seleccionados',
      },
      teams_tip: {
        subtitle:
          'Cuando envíes una transferencia a alguien, añadiremos a esa persona a tu lista de contactos. Todos los miembros de tu equipo pueden crear su propia lista.',
        title: 'Tu equipo Pro está creciendo…',
      },
    },
    unsubscribeexpiration: {
      button: 'Cancelar suscripción',
      button_unsubscribed: 'Volver a WeTransfer',
      description:
        '¿No quieres recibir tantos emails? ¡No hay problema! No volveremos a enviarte ningún email alertándote acerca de transferencias que estén a punto de caducar.',
      description_unsubscribed:
        'Ya no recibirás más mensajes de aviso sobre las transferencias que van a caducar.',
      no_email: 'ti',
      title: 'Cancelar suscripción a correos electrónicos recordatorios',
      title_unsubscribed: '¡Todo listo!',
      downloaded: {
        body: 'Perfecto. Puedes desactivar los avisos que indican que hay transferencias que ya han sido descargadas y están a punto de caducar. Esto no afecta la recepción de avisos acerca de transferencias que aún no han sido descargadas.',
        cta: 'Desactivar',
        title:
          '"Mis archivos han sido descargados, no necesito que me aviséis de que mis transferencias están a punto de caducar"',
      },
      not_downloaded: {
        body: 'Sin problemas. Puedes desactivar los avisos que indican que hay transferencias que aún no han sido descargadas y que están a punto de caducar.',
        cta: 'Desactivar',
        title:
          '¿Prefieres que no te avisemos de transferencias que están a punto de caducar?',
      },
      pro: {
        body_1:
          'Perfecto, puedes desactivar este tipo de aviso. A través de los detalles de tu transferencia podrás seguir viendo cuándo caducará la transferencia y podrás cambiar la fecha de caducidad cuando quieras.',
        body_2:
          'Psst, puedes contactar con nosotros a través de <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> si cambias de idea o te encuentras con algún problema, no te preocupes.',
        cta: 'Desactivar',
        title:
          '¿Prefieres que no te avisemos de transferencias que están a punto de caducar?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: '¿Seguro que quieres borrar tus cookies?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Consigue Pro hoy mismo por %{price} %{currency}/mes',
      },
    },
    advertise: {
      gallery: {
        preview: 'Previsualizar',
      },
      guidelines: {
        advert_static: {
          title: 'Fondo de pantalla estático',
        },
      },
    },
    billinginfo: {
      pagename: 'Información de facturación',
    },
    help: {
      button_all_answers: 'Más respuestas',
      page_title: 'Ayuda rápida',
      read_more: 'Más información',
      search_button: 'Buscar',
      search_placeholder: '¿Con qué podemos ayudarte?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Cargando...',
    },
    payment_update: {
      bancontact: {
        info: 'Ojo: para comprobar tus datos, Bancontact te cobrará un importe de 0,50 € una única vez.',
      },
      confirm_update: 'Confirmar',
      ideal: {
        info: 'Ojo: para comprobar tus datos, iDEAL te cobrará un importe de 0,01 € una única vez.',
      },
      info: 'Ojo: para verificar la exactitud de tus datos, iDEAL te cobrará una cuantía de 0,01 € una única vez.',
      sofort: {
        info: 'Ojo: para comprobar tus datos, SOFORT te cobrará un importe de 1 € una única vez.',
      },
      title: 'Actualizar datos de pago',
      update_in_progress: 'Actualizando tus datos...',
    },
    sign_in: {
      account: '¿Aún no tienes una cuenta?',
      upgrade: 'Contrata WeTransfer Pro',
    },
    signin: {
      account_cta: 'Crear cuenta',
      account_item_1: 'Envía hasta %{size_limit}',
      account_item_2: 'Gestiona tus transferencias',
      account_item_3: 'Almacena hasta %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Consigue WeTransfer Pro',
      plus_item_1: 'Envía hasta %{size_limit}',
      plus_item_2: 'Gestiona tus transferencias',
      plus_item_3: 'Almacena hasta %{storage_limit}',
      plus_item_4: 'Tus propios fondos',
      plus_item_5: 'Un URL personalizado',
      plus_item_6: 'Transferencias protegidas por contraseña',
      plus_month: '/mes',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Cancelar invitación',
      },
      invitees: {
        title: 'Invitado; esperando respuesta',
      },
      member: {
        action_demote: 'Quitar como administrador',
        action_promote: 'Convertir en administrador',
        action_revoke: 'Eliminar del equipo',
      },
      members: {
        title: 'En tu equipo',
      },
      no_access: {
        description: '¡En cuanto esté disponible, te avisaremos! ',
        title: 'Uups, parece ser que esta funcionalidad aún es top secret. ',
      },
      subtitle: {
        members: {
          one: '%{count} miembro',
          other: '%{count} miembros',
        },
        pending: '%{pendingCount} invitados',
      },
      tip: {
        button: 'Más información',
        subtitle:
          '¡Hemos mejorado la experiencia inmejorable de WeTransfer con el lanzamiento de Pro para Equipos! Añadir a más miembros no cuesta nada. Utiliza el sencillísimo formulario que tienes a continuación para poner en marcha tu equipo. ¡En cuanto acepten tu invitación estaréis listos para empezar!',
        title: 'La unión hace la fuerza...',
      },
      title: 'Equipo',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Caducará en %{expiry}',
      },
      recipients: 'Enviando a',
      upsell: {
        benefit_one: 'Sabrás cuándo se han descargado tus archivos',
        benefit_three: 'Podrás revisar y reenviar transferencias anteriores',
        benefit_two: 'Sabrás quién se descarga tus archivos',
        button: {
          action: 'Quiero saber más',
          cancel: 'No, gracias',
        },
        heading: 'Gestiona fácilmente tus transferencias con WeTransfer Pro',
        title: 'Los detalles de tu transferencia',
      },
    },
    transferReceived: {
      'empty-description':
        'Aquí encontrarás todas las transferencias que hayas recibido (no te preocupes, no consumen ningún espacio)',
      'empty-title': 'Controla tus transferencias',
      empty: {
        description:
          'Aquí encontrarás todas las transferencias enviadas a tu correo electrónico o subidas a tu cuenta; no te preocupes, no consumirán espacio de almacenamiento.',
      },
      banner: {
        freeUser: {
          text: 'Sube de categoría para recibir archivos con facilidad. Obtén una URL personalizada <strong>tunombre.wetransfer.com</strong> y una página con tu marca para las subidas.',
          link: 'Más información',
          cta: 'Actualizar',
        },
        paidUser: {
          withUrl: {
            text: 'Cualquiera puede enviarte transferencias de 200 GB a <strong>%{personalisedUrl}</strong>',
            cta: 'Copiar URL',
          },
          withoutUrl: {
            text: 'Configura tu URL <strong>tunombre.wetransfer.com</strong> y cualquiera puede subir archivos a tu cuenta.',
            link: 'Más información',
            cta: 'Ir a branding',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Darte de baja',
      back: 'Volver a WeTransfer',
      contact:
        'Psst, si te encuentras con algún problema no dudes en contactarnos en <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>. Estamos ahí para ti.',
      done: '¡Ya está!',
      message:
        'Puedes darte de baja de nuestra serie de e-mails introductorios. Pero no te preocupes, seguirás recibiendo los demás mensajes importantes.',
      title: '¿Se está llenando tu bandeja de entrada?',
    },
    userinfo: {
      pagename: 'Información personal',
    },
    free_onboarding: {
      close: 'Cerrar',
      finish_tour: 'Finalizar',
      next: 'Seguir',
      send_files: 'Ok, pero ahora quiero enviar archivos',
      start_tour: 'Ver todo lo demás que ofrecemos',
      step_one: {
        body_1:
          'Ahora que has verificado la dirección email para tu cuenta, ya no te tocará hacerlo de nuevo cada vez que vuelvas a enviar un archivo. ¡Se acabaron los códigos de verificación!',
        body_2:
          'Haz un seguimiento de todas las transferencias que has enviado y recibido desde un lugar. Mira cuántas veces se descargan tus archivos. Reenvía o elimina tus transferencias con un sólo clic.',
        header_1: 'Verificado una vez por todas',
        header_2: 'Organizar tus transferencias',
        subtitle:
          'Despídete de los códigos de verificación y los enlaces de descarga perdidos. Tu nueva cuenta te permitirá enviar archivos grandes de la forma más sencilla—de forma gratuita.',
        title_1: 'Enviar archivos <strong>del modo que tú quieras</strong>',
        title_2: 'con WeTransfer',
      },
      step_three: {
        body_1:
          'Ya sea un vídeo en tu teléfono o un enlace en tu portátil, guarda todo lo que te inspira en un único lugar. Para empezar, abre Collect utilizando el launcher (aquella cosa en la esquina superior izquierda) o utiliza uno de los enlaces de aquí abajo.',
        cta: 'Ir a Collect',
        title_1: '<strong>Guarda lo que te inspira</strong> estés donde estés',
        title_2: 'con Collect',
      },
      step_two: {
        body_1:
          'Presenta tus ideas. Muestra bocetos. Sigue sincronizado. Sin tener que formatear jamas otra diapositiva. Para empezar, abre Paste utilizando el launcher (aquella cosa en la esquina superior izquierda) o utiliza uno de los enlaces de aquí abajo.',
        cta: 'Ir a Paste',
        title_1: 'Crea <strong>presentaciones en pocos segundos</strong>',
        title_2: 'con Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Quiero probar portals',
        pill: 'Funcionalidad nueva',
        text: 'Te presentamos <strong>portals</strong>, un forma más sencilla de recibir feedback acerca de tu trabajo. Invita a clientes y colaboradores para que puedan ver archivos y seleccionar sus favoritos—todo sin tener que descargarse nada.',
        title: 'Comparte tu trabajo y colabora. En un mismo lugar.',
      },
    },
    not_found: {
      body: 'Vuelve a <a href="https://wetransfer.com/">wetransfer.com</a> o alégrate la vista con algunas <a href="https://wepresent.wetransfer.com/">cositas que hemos escrito</a>.',
      image_alt: 'Algo ha salido mal',
      title: 'Vaya, no se ha encontrado la página.',
    },
    password_and_security: {
      title: 'Contraseña y seguridad',
      'two-factor-authentication': {
        description: {
          enabled: 'Desde %{date}',
        },
        disable: 'Desactivar',
        done: 'Finalizar',
        enable: 'Activar',
        get_recovery_codes: 'Conseguir códigos de recuperación',
        next_step: 'Seguir',
        recovery_code_action: 'Generar códigos nuevos',
        recovery_code_keep_safe:
          'Cada código se puede utilizar una sola vez, pero siempre podrás conseguir códigos nuevos si te hacen falta.',
        recovery_code_need_more:
          '¿Necesitas más códigos de recuperación? Siempre podrás generar códigos nuevos, pero ten en cuenta que eso hará que los códigos que ya tengas dejen de funcionar.',
        recovery_code_title: 'Tus códigos de recuperación',
        require_password_action: 'Entrar',
        require_password_text: 'Introduce tu contraseña para continuar',
        step_one_action: {
          app_store: 'Descargar en App Store',
          google_play: 'Consíguelo en Google Play',
        },
        step_one_label: 'Paso 1 (de 3)',
        step_one_text:
          'Necesitarás una app de autenticación en tu teléfono. Si ya cuentas con Google Authenticator (o similar) en tu teléfono, dale a seguir.',
        step_one_title: 'Descargar Google Authenticator',
        step_three_label: 'Paso 3 (¡ya estás!)',
        step_three_text:
          'Si necesitas iniciar sesión, pero no tienes tu teléfono a mano (a veces pasa), podrás utilizar uno de estos códigos de recuperación. No guardamos los códigos en ningún lado, por lo que no te los podremos enseñar de nuevo, así que guárdalos bien y mantenlos seguros, como si fuera la contraseña de tu cuenta bancaria.',
        step_three_text_2:
          '¡Guarda estos códigos cuidadosamente, como si se tratase de la clave de acceso a tu cuenta bancaria! Cada código se puede utilizar una sola vez.',
        step_three_title: 'Guardar códigos de recuperación',
        step_two_form: {
          error: 'Ups, ese código no es correcto o ha caducado',
          label: 'Código de verificación',
        },
        step_two_label: 'Paso 2 (casi estás)',
        step_two_text:
          'Utiliza tu app de autenticación para escanear este código de barras. La app generará un código de verificación de seis dígitos; introdúcelo aquí abajo.',
        step_two_text_mobile:
          'Introduce la clave mostrada por tu app de autenticación. La app generará un código de verificación de seis dígitos; introdúcelo aquí abajo.',
        step_two_title: 'Escanea el código de barras',
        step_two_title_mobile: 'Introduce clave',
        text: {
          protect_account:
            'Protege tu cuenta con una nivel de seguridad adicional utilizando tu teléfono.',
        },
        title: 'Autenticación de dos factores',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Acceder a lo mejor de Paste® y Collect',
      },
      cta: 'No, quiero seguir utilizando Pro',
      'cta-2': 'Cancelar mi suscripción',
      disclaimer: {
        collect:
          'Tu espacio de almacenamiento disponible en Collect disminuirá de 200 GB a 5 GB',
        paste:
          'Pasarás de disponer de presentaciones infinitas a sólo 3 en Paste®',
        'team-member': 'Se te eliminará de %{currentTeam} en WeTransfer Pro.',
        teams:
          'Tu equipo de %{amountOfMembers} personas será eliminado de %{currentTeam} en WeTransfer Pro',
        title: 'Cuando tu suscripción se cancele el <strong>%{date}</strong>:',
        'transfer-expiry':
          'Tus transferencias existentes serán eliminadas después de 28 días',
        'transfer-team-member':
          'No podrás enviar ni recibir transferencias como parte del equipo y no podrás gestionar las transferencias de equipo existentes.',
      },
      'password-expiry': {
        title:
          'Transferencias protegidas con contraseñas y decidir cuándo caducan',
      },
      personalization: {
        title: 'Personalizar tu página WeTransfer personal',
      },
      portals: {
        text: 'Con %{planName}, puedes utilizar <a href="%{href}" target="_blank">portales</a> para compartir el trabajo para que los clientes lo revisen, sin necesidad de descargas.',
        title: 'Compartir trabajo y recibir feedback en un mismo lugar',
      },
      'stay-pro': 'Conservar suscripción',
      'storage-limit': {
        title:
          'Disfrutar de %{storage_limit_pro} en almacenamiento por persona',
      },
      subtitle:
        'Si cancelas tu suscripción ahora, a partir del %{date} dejarás de poder hacer lo siguiente:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Invita a miembros del equipo</a> a enviar, recibir y gestionar transferencias de forma conjunta, o trabaja en solitario de forma gratuita.',
        'team-member-text':
          'Se te eliminará de tu equipo y ya no podrás enviar, recibir ni administrar transferencias conjuntamente.',
        'team-owner-text':
          'Tu equipo cuenta con <a href="%{href}" target="_blank">%{amountOfMembers} miembros</a>, que dejarán de poder enviar, recibir y gestionar transferencias conjuntamente.',
        title: 'Elaborar grandes ideas en equipo',
      },
      title: '¿De verdad quieres renunciar a %{planName}?',
      'transfer-limit': {
        text: 'En estos momentos, puedes enviar y recibir transferencias más grandes, mucho más que los %{transfer_limit_free} gratuitos.',
        title: 'Enviar archivos 100 veces más grandes',
      },
      'transfer-unlimited': {
        text: 'Puedes enviar (y recibir) transferencias sin límite de tamaño—infinitamente más que los %{transfer_limit_free} de la versión gratuita.',
        title: 'Enviar transferencias de cualquier tamaño',
      },
    },
    pricing: {
      pro: {
        per_person: 'por persona',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Crear cuenta',
        current_plan: 'Plan actual',
        sign_up: 'Registrarse',
        switch_premium: 'Cambiar a Premium',
        switch_pro: 'Cambiar a Pro',
        upgrade: 'Contratar',
      },
      faq: {
        answers: {
          answer_1:
            'Podrás empezar a utilizar WeTransfer Pro o WeTransfer Premium en cuanto hayas completado el pago. Te enviaremos un email de confirmación y adjuntaremos tu factura pagada. <br /><br />\n\nUna vez suscrito, podrás enviar archivos de mayor tamaño, usar los portales y crear tu propia página de WeTransfer de inmediato. Si tienes transferencias anteriores enviadas con tu cuenta gratuita, podrás cambiar su fecha de caducidad a cuando quieras.',
          answer_2:
            'Cuando usas WeTransfer, cualquiera puede descargar tus archivos, sin necesidad de iniciar sesión o registrarse. Tendrá que aceptar nuestras condiciones de servicio, y es posible que le pidamos que acepte las cookies, ¡pero eso es todo! <br /><br /> \n \nSi quieres compartir tu trabajo o colaborar en los portales (la última herramienta de WeTransfer), tus clientes y colaboradores tampoco tendrán que registrarse para ver, seleccionar y descargar archivos, comentar o dar su aprobación. Solo tendrás que añadir a miembros del equipo a tu cuenta Pro o Premium si quieres que puedan añadir revisiones y crear portales contigo.',
          answer_3:
            'Con una cuenta Pro o Premium podrás crear tu propia página de WeTransfer, a la que cualquier persona te podrá enviar archivos dentro del límite de tamaño para transferencias de tu plan. Así que podrás recibir archivos grandes de tus clientes o colaboradores sin necesidad de que tengan una cuenta, solo con la URL de tu página (aunque puede que les pidamos que verifiquen su dirección de email para protegerte de "príncipes extranjeros" que "quieren mandarte dinero").',
          answer_4:
            'Primero tienes que contratar WeTransfer Pro o WeTransfer Premium. No puedes añadir miembros a tu equipo con una cuenta gratuita. Elijas el plan que elijas, todos los miembros de tu equipo disfrutarán de las mismas ventajas (así que no puedes contratar Premium para ti y que otras personas de tu equipo estén con Pro, por ejemplo). Los miembros del equipo podrán enviar y recibir archivos de mayor tamaño desde tu página de WeTransfer, así como gestionar transferencias desde un panel compartido. <br /><br /> \n\nUna vez hayas contratado el plan que mejor se adapta a tu equipo, podrás invitar a tantos miembros como quieras desde los ajustes de gestión del equipo. Puedes añadir miembros a tu equipo y eliminarlos en cualquier momento mientras tu suscripción esté en vigor.',
          answer_5:
            'Aceptamos tanto PayPal como las tarjetas de crédito de las principales entidades, como Visa, Mastercard y American Express. En algunos países también aceptamos otros métodos de pago en línea. <br /><br /> \n\nNo aceptamos transferencias bancarias directas porque la suscripción requiere pagos anuales o mensuales recurrentes. (Te mandaremos un email antes de que se te cobre por primera vez para avisarte.)',
          answer_6:
            'Si no disfrutas del almacenamiento ilimitado de WeTransfer Premium, tendrás que liberar algo de espacio borrando alguno de los archivos que has enviado o cambiar de suscripción. Hasta entonces no podrás realizar nuevas transferencias. <br /><br /> \n\nSi estás usando WeTransfer gratis, todas tus transferencias de hasta 2 GB se borran automáticamente después de 7 días. Así que no te preocupes, no puedes quedarte sin espacio de almacenamiento.',
          answer_6_variant_asterisk:
            'Tendrás que liberar algo de espacio eliminando algunas de las transferencias que has enviado o actualizar tu plan. Hasta que no lo hagas, no podrás enviar nuevas transferencias. <br /><br />\n\nSi tienes una suscripción Premium y has llegado a 5 TB, puedes ponerte en contacto con nuestro equipo de asistencia y solicitar más almacenamiento hasta un límite anual máximo de 15 TB. <br /><br />\n\nSi estás usando WeTransfer gratis, todas tus transferencias enviadas de hasta 2 GB se borran automáticamente después de 7 días. Así que no te preocupes, no puedes quedarte sin espacio de almacenamiento.',
          answer_6_variant_limited_storage:
            'Tendrás que liberar algo de espacio borrando algunas de las transferencias que has enviado o cambiar de plan (a menos que tengas una suscripción Premium). Hasta que no lo hagas, no podrás enviar nuevas transferencias. <br /><br />\n\nSi estás usando WeTransfer gratis, todas tus transferencias enviadas de hasta 2 GB se borran automáticamente después de 7 días. Así que no te preocupes, no puedes quedarte sin espacio de almacenamiento.',
          answer_7:
            'Tu suscripción se renovará automáticamente (te mandaremos un email antes de que pase por primera vez), pero la puedes cancelar en cualquier momento. <br /><br /> \n\nPara pasar a utilizar WeTransfer gratis, solo tienes que ir a los ajustes de tu <strong>Cuenta</strong> y cancelar tu suscripción. Tú y los demás miembros de tu equipo (si los hay) podréis seguir utilizando el plan Pro o Premium hasta que termine el periodo de suscripción vigente.',
          answer_8:
            'Millones de personas de todo el mundo confían en WeTransfer y nuestra gama de herramientas para transmitir sus ideas. Cada mes, 80 millones de personas comparten 2 mil millones de archivos en nuestra plataforma. <br /><br /> \n\nPara que tus ideas estén a salvo de cualquier ataque o abuso, tus archivos están cifrados cuando se transfieren (TLS) y cuando se almacenan (AES-256). Una vez almacenados, solo se puede acceder a ellos usando los enlaces únicos que se envían al emisor y al destinatario.',
        },
        questions: {
          question_1: '¿Qué ocurre después de registrarme y pagar?',
          question_2: '¿Se tienen que registrar mis destinatarios?',
          question_3:
            '¿Puedo recibir transferencias más grandes de cualquier persona? ',
          question_4: '¿Cómo añado (o elimino) a miembros del equipo?',
          question_5: '¿Qué métodos de pago puedo utilizar?',
          question_6: '¿Qué pasa si supero mi límite de almacenamiento?',
          question_7: '¿Cómo puedo cancelar mi suscripción?',
          question_8: '¿Me puedo fiar de WeTransfer? ¿Cómo de seguro es?',
        },
        title: 'Preguntas frecuentes',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Publicidad (y arte)',
            custom: 'Sube el tuyo propio',
            feature_1: 'Página WeTransfer personalizada',
            feature_2: 'Fondos de pantalla',
            feature_3: 'Emails de WeTransfer personalizados',
          },
          title: 'Exhibe tu marca',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} de almacenamiento',
            title: 'Collect de WeTransfer',
          },
          paste: {
            limited_decks:
              'Hasta %{pasteDecksLimit} presentaciones con el logo por defecto de Paste',
            title: 'Paste® de WeTransfer',
            unlimited_decks: 'Presentaciones ilimitadas con tu propio branding',
          },
          title: 'Completa tu kit de herramientas creativas',
        },
        expiry: 'Las transferencias caducan después de %{days} días',
        extra_storage: '%{storageLimit} más por persona',
        monthly_price: '%{price} al mes por persona',
        portals: {
          features: {
            feature_1: 'Portales',
            feature_2: 'Revisiones',
            feature_3: 'Branding del cliente',
          },
          title: 'Comparte tu trabajo para recibir comentarios y aprobación',
        },
        security: {
          features: {
            feature_1: 'Fechas de caducidad a medida',
            feature_2: 'Transferencias protegidas por contraseña',
            feature_3: 'Cifrado de datos',
            feature_4: 'Autenticación de dos factores',
          },
          title: 'Protege tus transferencias',
        },
        storage_limit: '%{storageLimit} por persona',
        teams: {
          features: {
            feature_1: 'Invita a miembros del equipo',
            feature_2: 'Resumen de transferencias compartido',
            feature_3: 'Almacenamiento compartido',
            feature_4: 'Branding compartido',
          },
          title: 'Entrega trabajo como un equipo',
          subtext: {
            text: 'Solo compatible si adquieres una suscripción en nuestro sitio web.',
            learn_more: 'Más información',
          },
        },
        tooltips: {
          tooltip_1:
            'Todas las transferencias que envías ocupan parte de tu espacio de almacenamiento',
          tooltip_10:
            'Puedes enviar y almacenar archivos de forma segura con el cifrado TLS y AES-256',
          tooltip_11:
            'Para hacer un seguimiento de las descargas y gestionar transferencias juntos',
          tooltip_12:
            'Presume de tu trabajo (o el de tu equipo) con emails y fondos de pantalla personalizados',
          tooltip_13:
            'Paste es una herramienta para realizar presentaciones que diseña diapositivas con colores, alineación y formatos variables',
          tooltip_14:
            'Collect te permite guardar y organizar imágenes, vídeos, música y enlaces en múltiples dispositivos',
          tooltip_2:
            'Otras personas pueden descargar tus archivos sin necesidad de registarse o iniciar sesión',
          tooltip_3:
            'Haz un seguimiento de quién ha descargado tus archivos (y quién no)',
          tooltip_4: 'Oganiza tu trabajo por cada cliente y proyecto',
          tooltip_5:
            'Invita a tus clientes a ver y seleccionar archivos, añadir comentarios y dar su aprobación, sin necesidad de descargar nada',
          tooltip_6:
            'Añade un logo y título para personalizar tus portales para cada cliente',
          tooltip_7:
            'Tu página de WeTransfer es el lugar donde otras personas pueden descargar tus archivos y enviarte transferencias dentro del límite de almacenamiento de tu plan',
          tooltip_8:
            'Los fondos de pantalla son los vídeos e imágenes que ves de fondo cuando estás enviando o recibiendo archivos en wetransfer.com',
          tooltip_9:
            'Vaya, creíamos que nadie se pondría a leer esto, pero has demostrado que estábamos equivocados. ¡Enhorabuena! Puede que compartamos capturas de pantalla en nuestra cuenta de Twitter de @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Límite de tamaño de transferencias',
            feature_2: 'Almacenamiento',
            feature_3: 'Descargas sin cuenta',
            feature_4: 'Seguimiento de las descargas',
            feature_5: 'Aplicación para iOS',
          },
          title: 'Envía archivos grandes',
        },
        unlimited: 'Sin límite',
        yearly_price: '%{price} al año por persona',
      },
      header: {
        subtitle:
          'Ya estés enviando archivos grandes por diversión o entregando trabajo a tus clientes, avanza en tus proyectos creativos con WeTransfer.',
        title: {
          english_1: 'Tienes las ideas;',
          english_2: 'nosotros, los planes',
          general: 'Planes y precios',
        },
      },
      plans: {
        billing: {
          discount: 'Ahorra un %{percentage} (¡oh sí!)',
          discount_up_to: 'Save up to %{percentage} (ooh yeah)',
          monthly: 'Facturación mensual',
          yearly: 'Facturación anual',
        },
        free: {
          subtitle: 'Enviar archivos de vez en cuando',
          title: 'Gratis',
          usp: {
            feature_1: 'Envía hasta %{transferLimit}',
            feature_2: 'No hace falta verificar transferencias',
          },
        },
        premium: {
          subtitle: 'Compartir trabajo sin límites',
          title: 'Premium',
          usp: {
            feature_1: 'Sin límite de tamaño para transferencias',
            feature_2: 'Almacenamiento ilimitado',
            feature_2_subtitle:
              '*El límite inicial es de %{storageLimit}, con la opción de añadir almacenamiento adicional bajo petición. Se aplica un límite máximo anual de %{annualStorageLimit}. Consulta nuestras <a href="/legal/terms" data-route-type="premium" target="_blank">Condiciones de servicio</a> para obtener más información.',
            feature_3: 'Portales y revisiones ilimitados',
          },
        },
        pro: {
          subtitle: 'Enviar archivos muy grandes a menudo',
          title: 'Pro',
          usp: {
            feature_1: 'Envía y recibe hasta %{transferLimit}',
            feature_2: '%{storageLimit} de almacenamiento por persona',
            feature_3: '%{portalsLimit} portal, revisiones ilimitadas',
          },
        },
        tagline: {
          free: 'sin pagar un solo céntimo',
          monthly: 'al mes por persona',
          yearly: 'al año por persona',
          per_person_monthly: 'por persona, facturado mensualmente',
          per_person_yearly: 'por persona, facturado anualmente',
          tax_included: 'impuestos incluidos',
        },
        title: 'Elige tu plan',
        month: 'mes',
      },
      skip_link: 'Saltar a más prestaciones',
    },
    pro_classic: {
      hero: {
        cta_1: 'Leer más',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Tú pones las ideas, y nosotros los planes',
      },
      cta: 'Simplemente quiero enviar archivos',
      free_panel: {
        cta: 'Date de alta',
      },
      plan: {
        free: {
          feature_1: 'Envía hasta <strong>%{transfer_limit}</strong>',
          feature_2: 'No hace falta verificar transferencias',
          subtitle_new: 'Para enviar archivos ocasionales',
          title: 'Gratuito',
        },
        pro: {
          feature_1: 'Envía y recibe hasta <strong>%{transfer_limit}</strong>',
          feature_2: 'Decide cuando caducan tus transferencias',
          feature_5: '1 TB de almacenamiento por persona',
          subtitle_new: 'Para profesionales y equipos',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Date de alta ahora',
          descripttion: 'Controla tus transferencias',
          feature_1: 'Enviar hasta 2 GB',
          feature_2: 'Recibir transferencias en un solo resumen',
          title: 'Gratis',
        },
        pro: {
          cta: 'Leer más',
          descripttion: 'WeTransfer Pro y Premium',
          feature_1: 'Envía y recibe hasta %{transfer_size}',
          feature_2:
            '%{storage_size} de almacenamiento de transferencias por persona',
          feature_3: 'Enviar transferencias con ajustes personalizados',
          title: 'Pro',
        },
        title:
          'No dejes que las transferencias se pierdan en tu bandeja de entrada.',
      },
      title: 'Aprovecha al máximo el nuevo WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Invitar equipo',
        pagename: 'Invitar equipo',
      },
      manage: {
        cta: 'Gestionar equipo',
      },
      members:
        'Tienes %{amountOfMembers} miembros en tu equipo. <a href="%{href}">%{cta}</a>',
      no_members: '¡Por ahora sólo estás tú! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Opciones de equipo',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Trabaja en equipo y transfiere en equipo',
        context:
          'Envía y recibe transferencias en equipo con almacenamiento compartido, branding y acceso a las transferencias de los demás.',
        invite_team: 'Invitar equipo',
        dismiss: 'Quizá más tarde',
      },
      feature_highlight: {
        free_context:
          'Ya puedes gestionar y recibir transferencias en un sencillo panel. Sabrás el minuto exacto en que se han descargado los archivos. Reenvía, remite y descarga transferencias con un solo clic. ¡Así de fácil!',
        free_subtitle: 'Todas tus transferencias en un solo lugar',
        paste_collect_link:
          'Accede a <a href="%{pasteUrl}" rel="external">%{pasteName}</a> o <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Ya puedes transferir archivos de cualquier tamaño y crear tu propia <b>página WeTransfer</b> para personalizar lo que otras personas ven cuando descargan tus archivos. ¿Listo para elegir tu URL y fondos de pantalla?',
        premium_cta: 'Crear página',
        premium_dismiss: 'Quizá más tarde',
        premium_subtitle: 'Configura tu página WeTransfer',
        premium_team_context:
          'Ya puedes enviar y recibir transferencias de cualquier tamaño desde la página WeTransfer personalizada de tu equipo.',
        pro_context:
          'Ya puedes enviar hasta %{transfer_limit} de golpe y crear tu propia <b>página WeTransfer</b> para personalizar lo que otras personas ven cuando descargan tus archivos. ¿Listo para elegir tu URL y fondos de pantalla?',
        pro_team_context:
          'Ya puedes enviar y recibir transferencias de %{transfer_limit} desde la <b>página WeTransfer personalizada</b> de tu equipo.',
        send_cta: 'Ir a enviar archivos',
        team_subtitle: 'Entrega trabajo creativo como un equipo',
      },
      marketing: {
        context:
          'Ahora que sabemos un poco más de ti, nos encantaría contarte más cosas sobre nosotros. ¿Quieres recibir historias sobre la creatividad y las últimas noticias de WeTransfer?',
        image_alt_text:
          'Contenido del email de ejemplo con nuevas prestaciones del producto, informes de la industria y artículos de WePresent con historias sobre la creatividad.',
        opt_in: 'Sí, por favor',
        opt_out: 'No, gracias',
        unsubscribe:
          'Siempre te puedes dar de baja más adelante. ¡No nos ofenderemos!',
      },
      welcome: {
        context: 'Conocerte mejor nos ayudará a mejorar nuestro servicio.',
        cta: 'Continuar',
        dismiss: 'Omitir',
        dropdown_options: {
          architecture: 'Arquitectura / Construcción',
          data: 'Datos / Finanzas / Legal',
          design: 'Diseño / Ilustración',
          education: 'Educación / Formación',
          marketing: 'Marketing / RR. PP.',
          music: 'Música / Sonido',
          other: 'Otro (y orgulloso de ello)',
          photography: 'Fotografía',
          product: 'Productos / Software',
          sales: 'Ventas / Relaciones con clientes',
          video: 'Vídeo / Animación',
        },
        free_tier_title: '¡%{name}, te damos la bienvenida a WeTransfer!',
        placeholder: 'Hmm, a ver...',
        question: 'Antes que nada, ¿en qué sector estás?',
        team_title: '¡Estás dentro del equipo, %{name}!',
        tier_title: '¡%{name}, te damos la bienvenida a WeTransfer %{tier}!',
        data_opt_in: {
          checkbox_label:
            'Permite a WeTransfer usar los datos que compartas para mostrarte anuncios personalizados dentro y fuera de nuestros sitios web.',
          tooltip_anchor: '¿Qué significa esto?',
          tooltip: {
            title: '¿Cómo utiliza WeTransfer mis datos?',
            p1: 'Utilizamos tu dirección de correo electrónico para mostrarte (a ti y a otras personas como tú) anuncios de WeTransfer en sitios web que visitas, como los de redes sociales.',
            p2: 'También usamos tu campo de trabajo para ofrecerte una mejor experiencia en nuestras páginas web.',
            p3: 'Los datos que decidas compartir con nosotros estarán protegidos en todo momento.',
            button: 'Entendido',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Añade a otros a tu espacio de trabajo',
      workspace: 'Espacio de trabajo',
      manage_workspace: 'Administrar espacio de trabajo',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, algo ha salido mal. Inténtalo de nuevo o contacta con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>.',
    complete_payment_exception:
      'Ups, algo ha salido mal, inténtalo de nuevo o ponte en contacto con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>',
    retrieve_checkout_exception:
      'Hmm, algo ha salido mal. Inténtalo de nuevo o contacta con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>.',
    source_id_error:
      'Lo sentimos, pero no hemos podido procesar esta solicitud. Inténtalo de nuevo.',
    three_d_secure: 'Actualmente no aceptamos las tarjetas 3D Secure.',
    something_went_wrong:
      'Ups, algo ha salido mal, inténtalo de nuevo o ponte en contacto con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>',
    signin_no_data_exception:
      'Mmm, algo ha salido mal, revisa tu nombre de usuario y contraseña e inténtalo de nuevo',
    signin_exception:
      'Lo sentimos, pero no hemos podido iniciar sesión. Inténtalo de nuevo.',
    signout_exception:
      'Vaya, parece que no podemos desconectarte. Es raro. Recarga la página para ver si sigues conectado.',
    signup_account_error:
      'Vaya, algo salió mal durante el inicio de sesión. Revisa tus datos e inténtalo de nuevo.',
    retrieve_account_exception:
      'Ups, algo salió mal. Nos fastidia tener que molestarte, pero, ¿podrías volver a intentarlo?',
    update_account_error:
      'Lo sentimos, pero no hemos podido actualizar los datos de tu cuenta. ¿Podrías intentarlo otra vez?',
    retrieve_subscription_exception:
      'No hemos encontrado tus datos de pago, por favor, inténtalo otra vez.',
    update_subscription_exception:
      'No hemos podido actualizar tus datos de pago. Inténtalo de nuevo o contáctanos desde el <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>',
    autorenewal_not_supported: 'Esta cuenta no admite la renovación automática',
    email_background_upload_validation_error:
      'Este archivo es demasiado grande, o no está en formato png o jpg; prueba con otra imagen',
    email_background_upload_validation_error_videos:
      'Este archivo es demasiado grande, o no está en formato png o jpg; prueba con otra imagen',
    update_password_exception:
      'Lo sentimos, pero no hemos podido actualizar tu contraseña. Inténtalo de nuevo.',
    retrieve_device_exception:
      'No hemos encontrado ningún dispositivo conectado. ¡Ni uno! Inténtalo de nuevo.',
    remove_device_exception: 'No hemos podido eliminar este dispositivo',
    renew_subscription_exception:
      'No hemos podido renovar tu cuenta en este momento. Inténtalo de nuevo más tarde.',
    invoices_retrieve_exception:
      'No hemos encontrado tus recibos. Inténtalo de nuevo.',
    invoice_download_exception:
      'No hemos podido descargar este recibo. Inténtalo de nuevo.',
    image_not_valid: 'Vaya, parece que no hemos podido subir esta imagen',
    update_profile_error:
      'Vaya, no hemos podido actualizar tu perfil. Inténtalo de nuevo.',
    retrieve_profile_exception:
      'No hemos encontrado la configuración de tu perfil. Inténtalo de nuevo.',
    s3_exception:
      'Ups, algo fue mal durante el proceso de subida de archivos. Inténtalo de nuevo.',
    file_size_limit_reached:
      'Más grande no es siempre mejor. Sube una imagen de 3 MB o más pequeña.',
    retrieve_transferlist_exception:
      'No hemos encontrado tu lista de transferencias',
    retrieve_transfer_exception:
      'No hemos encontrado los datos de la transferencia',
    delete_transfer_exception: 'No hemos podido borrar esta transferencia',
    delete_transfers_exception: 'No hemos podido eliminar estas transferencias',
    update_expiry_exception:
      'No hemos podido actualizar esta fecha de caducidad',
    add_contact_exception: 'No hemos podido añadir este contacto',
    complete_last_order_exception: 'No hemos podido completar tu pedido',
    edit_contact_exception: 'No hemos podido actualizar este contacto',
    remove_contact_exception: 'No hemos podido eliminar este contacto',
    request_password_reset_exception:
      'Lo sentimos, pero no hemos podido procesar esta solicitud para reiniciar una contraseña. Inténtalo de nuevo.',
    request_password_reset_no_user:
      'No reconocemos esta dirección de correo electrónico. Revísala e inténtalo de nuevo.',
    reset_password_error:
      'Ha surgido un problema mientras reiniciábamos tu contraseña, inténtalo de nuevo.',
    reset_password_exception:
      'Lo sentimos, pero no hemos podido reiniciar tu contraseña en este momento. Inténtalo de nuevo.',
    reset_password_token_invalid:
      'Vaya, el enlace de reinicio no funcionó, sigue las instrucciones que te enviamos por correo electrónico o empieza de nuevo',
    retrieve_last_order_exception: 'No hemos encontrado tu pedido',
    retrieve_ternot_exception:
      'Vaya, no encontramos tu transferencia, inténtalo de nuevo',
    signin_invalid_credentials:
      'La dirección de correo y la contraseña no coinciden, revísalas e inténtalo de nuevo',
    unsubscribe_expiration_exception:
      'Algo salió mal al cancelar tu suscripción, por favor, inténtalo de nuevo',
    unsubscribe_expiration_invalid_signature:
      'Vaya, este enlace para cancelar la suscripción no funcionó, inténtalo de nuevo',
    cancel_subscription_exception:
      'Parece ser que algo ha salido mal y no hemos podido cancelar tu suscripción. Por favor, inténtalo de nuevo más tarde.',
    payment_cancelled:
      'Ups, algo ha salido mal, inténtalo de nuevo o ponte en contacto con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>',
    profile_picture_upload_validation_error:
      'Este archivo es demasiado grande, o no está en formato png o jpg; prueba con otra imagen',
    reactivate_subscription_exception:
      'Algo ha salido mal, inténtalo de nuevo por favor',
    retrieve_contactlist_exception: 'No hemos encontrado tu lista de contactos',
    source_retrieve_error:
      'Ups, algo ha salido mal, inténtalo de nuevo o ponte en contacto con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>',
    token_error:
      'Algo ha no ha salido como tocaba. ¿A lo mejor funcionará si lo intentas de nuevo?',
    update_user_error:
      'Se ha producido un problema al actualizar tu información',
    wallpaper_upload_validation_error:
      'Este archivo es demasiado grande, o no está en formato png o jpg; prueba con otra imagen',
    wallpaper_upload_validation_error_videos:
      'Ups, parece ser que el vídeo que has elegido no cumple con nuestros requisitos. Inténtalo de nuevo.',
    declined_contact_bank_error:
      'Lo sentimos, no ha sido posible procesar tu pago — ponte en contacto con tu banco por favor',
    invalid_password: 'Contraseña no reconocida',
    otp_token_invalid: 'Ups, el código no es correcto o ha caducado',
    projects_load_exception:
      'No podemos cargar tus proyectos en estos momentos',
    update_information_throttle:
      'Se ha producido un problema al actualizar tu información Tómate un descanso de %{throttle_time} antes de volver a intentarlo.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
    price_general_error_transfer_details:
      'The price could not be updated, please try again',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Productos',
        plans_and_pricing: 'Planes y precios',
        pricing: 'Tarifas',
        pro_and_premium: 'WeTransfer Pro y Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Anúnciate',
        upgrade: 'Ampliar',
      },
      name_1_2019: 'Empresa',
      name: 'Empresa',
    },
    home: {
      name: 'Inicio',
    },
    help: {
      name: 'Ayuda',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transferencias',
        contacts: 'Contactos',
        profile: 'Profile',
        account: 'Cuenta',
        received: 'Recibido',
        sent: 'Enviado',
        teams: 'Equipo',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Salir',
    signin: {
      name: 'Entrar',
    },
    branding: 'Configuración del perfil',
    label: {
      beta: 'Beta',
      new: 'Nuevo',
    },
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    portals: 'Portales',
    signup: 'Date de alta',
    features: {
      name: 'Uso',
      all: 'Todas las funciones',
      file_sharing: 'Para compartir archivos',
      collaboration: 'Para la colaboración',
      security: 'Para la seguridad de los datos',
      branding: 'Para el branding',
      fast_feedback: 'Para obtener comentarios rápidos',
    },
    referral: 'Recomienda a amigos',
    switcher: {
      create_free_account: 'Añadir gratuitamente',
      just_you: 'Sólo tú',
      team: 'Equipo',
      team_member_count: '%{amountOfMembers} miembros',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Vaya, no tienes conexión a internet.',
        begins_space:
          'No podemos enviar archivos cuyo nombre empieza con un espacio. Por favor cámbiale el nombre e inténtalo de nuevo.',
        begins_stop:
          'No podemos enviar archivos cuyo nombre empieza con un punto. Cámbiale el nombre e inténtalo de nuevo.',
        blocked: 'No hemos podido cargar WeTransfer, pareces estar bloqueado',
        generic: 'Lo sentimos pero algo salió mal durante la transferencia',
        has_blackslash:
          'No podemos enviar archivos cuyo nombre comienza con una barra invertida. Por favor cámbiale el nombre e inténtalo de nuevo.',
        has_linebreak:
          'No podemos enviar archivos cuyo nombre comienza con un salto de línea. Por favor cámbiale el nombre e inténtalo de nuevo.',
        incorrect_recipient:
          'Parece que una de las direcciones de correo electrónico introducidas no es correcta',
        incorrect_sender:
          'Parece que hay un problema con tu dirección de correo electrónico',
        io_error: 'Hay un problema con tus archivos',
        long_filename:
          'No podemos enviar archivos cuyos nombres contengan más de 250 caracteres. Por favor cámbiale el nombre e inténtalo de nuevo.',
        long_message: 'Ese mensaje es demasiado largo. Por favor, acórtalo.',
        missing_default_recipient:
          'Solo las direcciones de correo electrónico registradas en WeTransfer Pro pueden recibir más de %{free_transfer_limit}. Por favor, refresca la página para empezar de nuevo.',
        no_clipboard: 'Parece que no has copiado el enlace',
        no_files: '¡Parece que aún no has añadido ningún archivo!',
        no_folders:
          'Tienes que comprimir la carpeta antes de que podamos enviarla',
        no_recipient:
          'Necesitamos la dirección de correo a la que quieres que enviemos los archivos',
        no_sender:
          'Solo necesitamos tu dirección de correo electrónico para continuar',
        too_big:
          '¡Guau! No podemos transferir más de %{upload_limit} de una vez.',
        too_many_recipient:
          'Uy – %{count} destinatarios es nuestro límite. ¿Necesitas más? Te aconsejamos utilizar un enlace de transferencia.',
        unavailable:
          'Lo sentimos, esta transferencia ha sido eliminada y ya no está disponible',
        wrong_password:
          'La contraseña no es correcta. Inténtalo de nuevo o pregúntale a la persona que te envió la transferencia.',
        default_title: '¡Ups!',
        duplicate_filename:
          'Lo sentimos, no es posible enviar varios archivos con el mismo nombre. Cambia el nombre e inténtalo de nuevo, gracias.',
        firstaccept: 'Debes confirmar antes de enviar',
        not_downloadable:
          'Vaya, algo salió mal mientras buscábamos tus archivos. Recarga la página e inténtalo de nuevo gracias.',
        recaptcha: {
          text: 'Algo salió mal. ¡Inténtalo de nuevo, por favor!',
          title: 'Ups...',
        },
        too_big_text:
          'No puedes enviar más de %{upload_limit} a la vez. Envía hasta %{plus_limit} con Pro. ',
        too_big_title: 'Hey, campeón de los envíos',
        too_many_files: 'No puedes enviar más de %{count} archivos a la vez',
        too_many_recipient_text:
          'Puedes enviar archivos a hasta 50 personas a la vez con Pro.',
        too_many_recipient_title: 'Has seleccionado demasiados destinatarios',
        unavailable_forward:
          'Parece que esta transferencia fue borrada. Lo sentimos, pero no puede ser reenviada.',
        verify: {
          button: '¡Un código nuevo, por favor!',
          text: 'Inténtalo otra vez o pide un código nuevo. ',
          title: '¡Uups!',
        },
      },
      buttons: {
        check_out: '¡Échale un vistazo!',
        help: 'Centro de ayuda',
        plus: 'Consigue Pro',
        get_link: 'Mostrar enlace',
      },
      tips: {
        change_type:
          'Envía tu enlace de transferencia por correo-e o crea un enlace que podrás compartir cómo desees',
        contacts:
          'Cualquier persona a la que envíes archivos se añadirá automáticamente a tus contactos',
        expiry:
          'Con WeTransfer Pro podrás decidir cuándo caducan tus transferencias. (¡Incluso puedes cambiar la fecha de caducidad después de efectuar la transferencia!)',
        free_limit:
          'Buenas noticias, puedes enviar hasta %{size} de una vez. Y mejor aún, ¡puedes usar el servicio tan a menudo como desees!',
        message:
          'Si lo deseas, puedes añadir aquí un mensaje que acompañe a tu transferencia',
        password:
          'Puedes proteger una transferencia mediante contraseña para darle mas seguridad. Ten en cuenta que nosotros no añadimos la contraseña en el correo, ¡así que tendrás que dársela tú a la persona correcta!',
        recipient_limit:
          'Añade hasta %{email_limit} direcciones de e-mail o abre el menú junto al botón de transferencia para crear un enlace',
        transfer_history:
          'Tu transferencia aparecerá en el resumen de transferencias',
        your_email:
          'Escribe aquí tu dirección de correo para que podamos indicarte cuándo se han descargado tus archivos',
        link_transfer:
          '¿Sabías que tienes el enlace de tu transferencia aquí mismo?',
        previews_receiver:
          'Las imágenes que envían los usuarios de Pro pueden ser previsualizadas antes de su descarga. Solo tienes que pinchar sobre un archivo para ver su contenido.',
        previews_sender:
          'Ahora es posible previsualizar tus imágenes enviadas antes de descargarlas',
        vrl_text:
          'Ahora puedes echar un vistazo a tus archivos sin tener que descargarlos.',
        vrl_title: 'Previsualizar archivos',
        zip_text: '¿Vas a enviar una carpeta? La comprimiremos para ti.',
        zip_title: 'No hace falta que comprimas nada',
        add_display_name_tooltip:
          'Dale un título a tu transferencia para que los destinatarios sepan de que va. También hará más fácil encontrar cosas luego.',
        anonymous_sender: {
          button: 'Consigue un enlace',
          text: 'Introduce tu dirección email y te avisaremos cuando se hayan descargado tus archivos.\n\nDeberás verificar tu email para que nos podamos asegurar de que realmente eres tú. ¿Prefieres no tener que hacerlo cada vez?',
          text_locked_recipient:
            'Introduce tu dirección email y te avisaremos cuando se hayan descargado tus archivos.\n\nDeberás verificar tu email para que nos podamos asegurar de que realmente eres tú.',
        },
        prefer_link: {
          button: 'Consigue un enlace',
          text: '¿Prefieres no verificar tu dirección email? No hay problema.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Más información',
        previews_sender_learnmore: 'Más información',
      },
      recipient_locked_text:
        'Esta página sirve para que el propietario reciba archivos. Inicia sesión si eres tú, o visita <a href="https://wetransfer.com">wetransfer.com</a> para enviar archivos a otra persona.',
      recipient_locked_title: 'Atención',
      title: {
        previews_receiver: 'Previsualizar imágenes',
        previews_sender: 'Previsualizar imágenes',
      },
    },
    download: {
      blocked: {
        link: 'Más información',
        text: 'Esta transferencia ha sido denunciada y no se puede descargar',
        title: 'Transferenc. bloqueada',
      },
      title: 'Listos cuando tú lo estés',
      expires: 'Tus transferencias caducarán en %{relative_time}',
      expires_never: 'Sin fecha de caducidad',
      files: '%{count} archivos, %{size}',
      format: '%{files}・%{expires}',
      expand: 'más',
      download_link: 'Enlace de descarga',
      files_nosize: {
        one: '%{count} archivo',
        other: '%{count} archivos',
      },
      show_all_files_mobile: 'Mostrar todos los archivos',
      zip_information:
        'Recibirás un archivo comprimido de tipo .zip cuando descargues todos tus archivos de una vez, <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">obtén más información</a>',
      files_label: 'Files',
      message: 'Mensaje',
      learn_more: 'más información',
      expires_in: 'Caducará en %{expiry}',
      download_all_zip:
        'Descargar todo descargará todos los archivos en formato .zip',
      back_to_transfer: 'Volver a la transferencia',
      cookie_text:
        'Utilizamos cookies para ofrecerte la mejor experiencia. No temas, no vendemos tus datos a terceros. Gestiona tus <a href="https://wetransfer.com/legal/manage-cookies" rel="external">preferencias de datos</a>.',
    },
    preview: {
      open_grid: 'Previsualizar',
      click_to_open: 'Pulsa para previsualizar',
      grid: 'Elementos de esta transferencia',
      link: 'Sitio web',
      not_previewable: 'Sin vista previa',
      now_open: 'Previsualizando',
      open_link: 'Abrir enlace en una pestaña nueva',
      open_link_short: 'Abrir enlace',
      overview: 'resumen',
      reload: 'Pulsa aquí para recargar',
      something_went_wrong: 'Ups, algo salió mal',
      tap_to_open: 'Toca para mostrar',
      toobig_copy:
        'Solo podemos mostrar imágenes de hasta 50 MB. <a href="https://wetransfer.zendesk.com/" rel="external">Aquí tienes más info</a>.',
      toobig_title:
        '¡Uy! Esta imagen es demasiado grande para ser previsualizada',
      unsupported_copy:
        'Echa un vistazo a <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">este artículo</a> para conocer los tipos de archivos que pueden ser previsualizados',
      unsupported_title: 'Aún no es posible previsualizar este archivo',
      visit_website: 'Visitar sitio web',
    },
    complete_mobile: {
      email_text:
        'El email de transferencia ha sido enviado. Los archivos podrán descargarse durante %{expires}.',
      link_text: 'Copia tu enlace de descarga:',
      email_text_no_expiry: 'Un email ha sido enviado al destinatario.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>¿Sabías que ofrecemos el 30% de nuestro espacio publicitario a artistas?</b> Al aceptar nuestras cookies, nos permitirás mostrarte un poco de arte, información acerca de causas que nos importan, y anuncios galardonados que no te molestarán ni lo más mínimo. ',
          text: '¿También quieres permitir cookies por parte de nuestros socios publicitarios externos para que podamos personalizar los anuncios que ves? ',
          title: 'Nuestras cookies alimentan a la cultura',
        },
        subtitle:
          '<b>Por eso ofrecemos el 30% de nuestro espacio publicitario a artistas.</b> Al aceptar nuestras cookies, nos permitirás mostrarte un poco de arte, información acerca de causas que nos importan, y anuncios galardonados que no te molestarán ni lo más mínimo. ',
        text: 'Nuestra página web utiliza cookies para poder funcionar, comprender cómo utilizas WeTransfer y poder mejorar su rendimiento. ¿También quieres permitir cookies por parte de nuestros socios publicitarios externos para que podamos personalizar los anuncios que ves?',
        title: 'Creemos que el arte puede mover montañas',
        'title-small': 'Bienvenido a WeTransfer',
      },
      'button-accept': 'Acepto',
      'button-accept-all': 'Aceptar todo',
      'button-ccpa': 'Darse de baja de la venta de información personal',
      'button-cookies-privacy': 'Tus opciones de privacidad',
      'button-reject': 'No gracias',
      'button-save': 'Guardar',
      'button-save-and-exit': 'Guardar y cerrar',
      'ccpa-banner-text':
        'Utilizamos cookies para asegurarnos de que tengas la mejor experiencia en nuestro sitio web. No temas, no vendemos tus datos a terceros. ¿Quieres darte de baja de todos modos? <a href="%{href}">Gestionar la configuración</a>',
      'ccpa-body':
        'Como estás en Estados Unidos, tus derechos están protegidos por la Ley de Privacidad del Consumidor de California (CCPA) y puedes pedirnos que dejemos de vender tu información personal. Esto no significa que subastemos tus datos personales o archivos privados al mejor postor, nunca lo hemos hecho y nunca lo haremos. Hacemos todo lo posible para que tu huella digital sea pequeña, segura y esté bajo tu control. Puedes obtener más información sobre los datos que recopilamos y por qué lo hacemos en <a href="%{href}">Tus opciones de privacidad</a>.',
      'ccpa-donotsell': 'No vender mis datos personales',
      'ccpa-header': 'Darse de baja de la venta de información personal',
      'ccpa-intro':
        'Como empresa tecnológica responsable y comprometida con un internet mejor, no vendemos tus datos a terceros. Pero tienes derecho a darte de baja oficialmente de todos modos.',
      'ccpa-variant-test-text':
        'Utilizamos cookies para asegurarnos de que tengas una experiencia fluida en nuestro sitio web y para personalizar los anuncios que ves. <a href="%{href}">Administrar cookies</a>',
      headline: 'Cookies y anuncios',
      intro:
        'Utilizamos los ingresos generados a través de nuestros preciosos anuncios para pagar las facturas. De ese modo podemos ofrecer nuestro servicio para compartir archivos de forma gratuita.',
      'manage-cookies': 'Administrar cookies',
      'partners-consent': 'Permiso',
      'partners-features': 'Uso',
      'partners-headline': 'Nuestros socios',
      'partners-text':
        '<p>Aquí tienes una lista en orden alfabético de los socios que hemos seleccionado cuidadosamente, para que nos ayuden a hacer un seguimiento de tus datos con el fin de poder mejorar nuestro servicio.</p>',
      'preferences-headline': 'Administrar cookies ',
      'preferences-text':
        '<p>Respetamos tu derecho a la privacidad y tu libertad a la hora de elegir cómo se podrán utilizar tus datos. Necesitamos procesar información personal cuando utilizas nuestras herramientas, pero nos sentimos muy comprometemos a la hora de asegurar que llevamos nuestro negocio, tecnología y nuestra relación contigo de una forma responsable y ética.</p>\n<p>Por esa razón intentamos asegurarnos en todo momento de que tu huella digital sea pequeña, segura y siga siempre bajo tu control.</p>\n<p>Por defecto, sólo procesamos y almacenamos datos cuando es estrictamente necesario. Si deseas ayudarnos y así asegurar que podamos seguir ofreciendo nuestro servicio de forma gratuita, te queremos pedir permiso para compartir información con nuestros socios publicitarios.</p>',
      'preferences-text-allow-cookies':
        'Permitir cookies para que nosotros y/o nuestros socios puedan:<br><br>',
      'purpose-description-first-intro':
        'Para promocionar productos dentro y fuera de nuestra página web y apps, WeTransfer puede: ',
      'purpose-description-first-list':
        '<ul><li>Almacenar información acerca del modo en el que interactúas con nuestra(s) página(s) web, como por ejemplo dónde pinchas con el ratón y los enlaces que visitas, y (cuando posible) combinar esa información con datos que hemos almacenado acerca de ti, como por ejemplo tu dirección de email</li><li>Utilizar la información que almacenamos para enviarte ofertas y promociones por email; en nuestra(s) propia(s) página(s) web o apps; y las páginas web o apps de terceros. Un ejemplo de esto sería una promoción que te mostramos de uno de nuestros otros servicios cuando utilizas WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'Para promocionar productos en y fuera de nuestra página web y apps, nuestros socios pueden: ',
      'purpose-description-second-list':
        '<ul><li>Almacenar información acerca del modo en el que interactúas con nuestra(s) página(s) web, como por ejemplo dónde pinchas con el ratón y los enlaces que visitas, y (cuando posible) combinar esa información con datos que han almacenado acerca de ti</li><li>Utilizar la información que tienen almacenada para enviarte ofertas y promociones por email; en su(s) propia(s) página(s) web o apps; y las páginas web o apps de terceros con los que colaboran.</li></ul>',
      'purpose-title':
        'Promocionar productos en y fuera de nuestra página web y apps',
      'switch-by-partners': 'Por parte de nuestros socios',
      'switch-by-we-transfer': 'Por parte de WeTransfer',
      text: '<p>Nuestra página web utiliza <a href="%{href}">cookies</a> para funcionar correctamente, que también nos permiten analizar la forma en la que interactúas con ella y nos ayuda a mejorar su funcionamiento.</p>\n<p>¿También quieres permitir el uso de cookies que provienen de nuestros socios publicitarios? De ese modo podremos personalizar los anuncios que te mostramos, así como promocionar productos de WeTransfer y otras empresas asociadas dentro y fuera de nuestras páginas web y apps.</p>',
      'text-panel':
        '<p>Nuestra página web utiliza cookies para funcionar correctamente, que también nos permiten analizar la forma en la que interactúas con ella y nos ayuda a mejorar su funcionamiento.</p> \n<p>¿También quieres permitir el uso de cookies que provienen de nuestros socios publicitarios? De ese modo podremos personalizar los anuncios que te mostramos, así como promocionar productos de WeTransfer y otras empresas asociadas dentro y fuera de nuestras páginas web y apps.</p>',
      'tos-experiment': {
        'cookie-intro':
          'La forma más sencilla de enviar archivos grandes mientras descubres piezas de arte y anuncios galardonados.',
        'cookie-text':
          'Nuestra página web utiliza cookies para poder funcionar, comprender cómo interactúas con ella y poder mejorar su rendimiento. \nAl aceptar nuestras cookies, nos permitirás mostrarte anuncios personalizados. ¿Hemos repetido suficientes veces la palabra cookie? (Cookie.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Nuestra misión radica en hacer más bonito el mundo a través de los anuncios galardonados que no incordian nada de nada y nos permiten contribuir a la recuperación de la flora marítima.',
          title: 'Nuestras cookies protegen al planeta',
        },
        subtitle:
          'Al aceptar nuestros cookies, nos ayudarás directamente a cumplir con nuestro cometido para ayudar al planeta. En lo que llevamos de año, WeTransfer ha prometido plantar 175.000 árboles, y sólo es el principio. Tendrás un impacto positivo con tan solo disfrutar de nuestros anuncios galardonados. ',
        text: 'Nuestra página web utiliza cookies para mejorar su funcionamiento, ofrecer un mejor servicio y comprender mejor lo que necesitas. Al aceptar nuestros cookies de terceros, nosotros y nuestros socios podremos ofrecerte anuncios relevantes dentro y fuera de nuestras páginas web y aplicaciones.',
        title: 'Transfiere ideas.<b>Cambia el mundo.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Activa Collect Pro',
      title: 'Guarda y comparte inspiración mientras vas de camino',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Cuéntame más',
      title: 'Paste® Pro y Collect Pro ahora van incluidos en tu suscripción',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Activa Paste® Pro',
      title: 'Convierte tus grandes ideas en presentaciones preciosas',
    },
    terms_conditions: {
      experiment: {
        text: 'Para continuar, acepta nuestros <a href="/legal/terms" data-route-type="plus">términos de servicio</a> por favor.',
        title: "Ya estás <span class='tc-title-exp'>casi</span>.",
        ustitle:
          "Te damos la bienvenida a la forma más sencilla de <span class='tc-title-exp'>enviar archivos grandes.</span>",
      },
      title: 'Primero...',
      text: 'Para seguir, rogamos aceptes nuestras <a href="/legal/terms" data-route-type="plus">Condiciones del servicio</a> y <a href="/legal/privacy" data-route-type="plus">Política de cookies</a>. Usamos cookies con fines funcionales y estadísticos, y cookies de terceros con fines publicitarios.',
      language: 'Has establecido tu idioma a',
      button: 'Acepto',
    },
    upsell_pricing: {
      text: 'Comparar planes',
      title: '¿Quieres enviar transferencias más grandes?',
      receiving: {
        title: '¿Quieres aprovechar WeTransfer al máximo?',
      },
    },
    welcome: {
      card1:
        'Envía y recibe %{transfer_limit} en transferencias utilizando un <strong>resumen compartido</strong>',
      card2:
        'Envía tu trabajo desde una <strong>página WeTransfer personalizada</strong> compartida con tu equipo',
      card3:
        'Crea presentaciones en <strong>Paste®</strong> y boards en <strong>Collect</strong>, juntos',
      cta: 'Empecemos',
      headline: 'Bienvenido al equipo, <strong>¡%{first_name}!</strong>',
      'opt-in':
        'Envíame historias relacionadas a la creatividad y novedades WeTransfer',
    },
    form: {
      num_files: {
        one: '%{count} añadido · %{remaining} disponibles',
        other: '%{count} añadidos · %{remaining} disponibles',
      },
      add_files: 'Subir archivos',
      more_files: 'Añade más archivos',
      available_space: 'Añade hasta %{size}',
      message: 'Mensaje',
      from: 'Tu email',
      to: 'Enviar email a',
      other_recipients: {
        one: '%{count} más',
        other: '%{count} más',
      },
      reset_forward: 'Cancelar este reenvío',
      drop_files: 'o arrastra y coloca',
      files_count: {
        one: '%{count} archivos añadidos · %{fileSize} totales',
        other: '%{count} archivos añadidos · %{fileSize} totales',
      },
      select_folder: 'O selecciona una carpeta',
    },
    progress: {
      title: 'Subiendo...',
      title_finalizing_one: 'Finalizing...',
      title_finalizing_two: 'Almost there...',
      title_finalizing_three: 'One more moment...',
      title_finalizing_four: 'Wrapping up...',
      subtitle_finalizing:
        'Do not close this window until we complete the transfer',
      title_cancel: '¿Quieres cancelar esta transferencia?',
      uploaded: '%{sent} de %{total} subidos',
      remaining: {
        minutes: {
          zero: 'Queda menos de un minuto',
          one: 'Queda un minuto aproximadamente',
          other: 'Quedan unos %{count} minutos',
        },
        hours: {
          one: 'Queda una hora aproximadamente',
          other: 'Quedan unas %{count} horas aproximadamente',
        },
      },
      document_title: '%{percentage}% - Transfiriendo...',
      meta: {
        email: {
          one_file_one_recipient:
            'Enviando %{filesCount} archivo a %{recipientsCount} destinatario',
          one_file_other_recipients:
            'Enviando %{filesCount} archivo a %{recipientsCount} destinatarios',
          other_files_one_recipient:
            'Enviando %{filesCount} archivos a %{recipientsCount} destinatario',
          other_files_other_recipients:
            'Enviando %{filesCount} archivos a %{recipientsCount} destinatarios',
        },
        link: {
          one: 'Enviando %{count} archivo',
          other: 'Enviando %{count} archivos',
        },
      },
    },
    complete_link: {
      title: '¡Listo!',
      text: 'Copia tu enlace de descarga o <a href="/transfer/progress">échale un vistazo al contenido</a>',
      text_copied: 'El enlace ha sido copiado a tu portapapeles',
      text_manual_copy:
        'Tu enlace está listo \nPulsa %{shortcut} para copiarlo al portapapeles',
      document_title: '¡Hecho!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Tu transferencia ha sido reenviada',
    },
    complete_email: {
      title: '¡Listo!',
      text: 'El email de transferencia ha sido enviado. Los archivos podrán descargarse durante %{expires}. <a href="/transfer/progress">Échale un vistazo al contenido</a>.',
      text_no_expiry:
        'El email de transferencia ha sido enviado. <a href="/transfer/progress"> Échale un vistazo al contenido</a>.',
      document_title: '¡Enviado!',
      text_no_details:
        'El email de transferencia ha sido enviado. Los archivos podrán descargarse durante %{expires}.',
      team_discovery_title: '¡Transferencia enviada!',
      team_discovery_text:
        'La transferencia podrá descargarse durante %{expires}',
    },
    failed: {
      title: 'Vaya, algo salió mal',
      text: 'Parece que hubo problemas con la transferencia, inténtalo de nuevo',
    },
    pending: {
      title: 'Ya casi lo tenemos...',
      subtitle: 'Preparando...',
    },
    downloading: {
      title: 'Obteniendo tus archivos...',
      text: 'Estamos preparando tu descarga',
    },
    downloaded: {
      title: 'Tu descarga ha comenzado',
      text: 'Una vez finalizada, los archivos estarán en tu ordenador (generalmente, en la carpeta de descargas)',
      download_links:
        'Ten en cuenta que los enlaces pertenecientes a este Board no aparecerán. Encontrarás <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">más información aquí</a>.',
    },
    expired: {
      title: 'Transferencia caducada',
      text: 'Lo sentimos pero esta transferencia ha caducado y ya no está disponible',
    },
    password: {
      title: 'Introduce una contraseña',
      text: 'Necesitas una contraseña para poder llevar a cabo esta descarga',
    },
    options: {
      transfer_type: 'Enviar como',
      password: 'Contraseña',
      password_placeholder: 'Establecer',
      expiry: 'Caduca tras',
      expire_in: {
        '1w': '1 semana',
        '2w': '2 semanas',
        '1m': '4 semanas',
        never: 'Nunca',
        '14d': '2 semanas',
        '28d': '4 semanas',
        '365d': '1 año',
        '7d': '1 semana',
        '90d': '3 meses',
      },
      email: 'e-mail',
      link: 'enlace',
      email_transfer: 'Enviar transferencia por email',
      transfer_link: 'Conseguir enlace de transferencia',
    },
    buttons: {
      transfer: 'Enviar',
      forward: 'Reenviar',
      new_transfer: '¿Enviar archivo?',
      cancel: 'Cancelar',
      cancel_no: 'No',
      cancel_yes: 'Sí',
      copy_link: 'Copiar enlace',
      ok: 'Aceptar',
      done: '¿Enviar otro?',
      team_discovery_done: 'Enviar nueva transferencia',
      retry: 'Inténtalo de nuevo',
      continue: 'Continuar',
      download: 'Descargar',
      download_all: 'Descargarlo todo',
      back_to_home: 'Volver a Inicio',
      cleanup: 'Revisar transferencias ',
      download_all_files: 'Descargar todos los archivos',
      help: 'Centro de ayuda',
      payment: 'Renovar ahora',
      complete_order: 'Ir a facturar',
      download_all_experiment: 'Descargarlo todo en un .zip',
      download_experiment: 'Descargar archivo',
      download_file: 'Descargar archivo',
      download_zip: 'Descargarlo todo en un .zip',
      get_link: 'Mostrar enlace',
      go_to_transfer: 'Ir a transferencia',
      openinapp: 'Guárdalo con la app WeTransfer',
      openinapp_experiment: 'Guárdalo con la app WeTransfer',
      openincollectapp: 'Guardar con la aplicación Collect',
      get_a_link: 'Utilizar enlace',
    },
    account_expired: {
      text: 'Renueva ahora tu suscripción para seguir disfrutando los beneficios de tu cuenta Pro, o <a href="#signout">cierra la sesión para usar nuestro servicio gratuito</a>',
      title: 'Tu cuenta Pro ha caducado',
    },
    invalid: {
      text: 'No hemos encontrado tus archivos',
      title: 'Ups!',
      link: 'Más información',
    },
    outdated_browser: {
      text: 'WeTransfer funciona en una amplia variedad de navegadores web pero parece que el tuyo está un tanto obsoleto, actualízalo a una versión más reciente',
      title: 'Tu navegador web está obsoleto',
    },
    spam: {
      text: 'Esta transferencia fue reportada como spam asi que ha sido borrada',
      title: 'Mmm...',
    },
    upsell: {
      text: 'Aumentar límite',
      limit: 'Hasta %{limit} gratis',
      remaining: 'Queda(n) %{remaining}',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Consigue WeTransfer Pro',
      title: 'Protege tus transferencias al máximo poniéndoles contraseña',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Consigue WeTransfer Pro',
      title: 'Gestiona tus transferencias de forma fácil e inteligente',
    },
    upsell_one: {
      bubble: {
        button: 'Consigue Pro',
        text: 'Protege tus archivos con contraseña y decide cuando caducarán tus transferencias',
        title: '¿Quieres subir de nivel?',
        text_experiment:
          'Con Pro puedes configurar una contraseña y fecha de caducidad para tus transferencias.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer en Facebook',
      title: 'Únete a la comunidad de WeTransfer en Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Consigue WeTransfer Pro',
      title: 'Personaliza tu perfil de WeTransfer',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Consigue WeTransfer Pro',
      title: 'Transferencias más grandes, rápidas, mejores y potentes',
    },
    account_inactive: {
      text: 'Completa tu registro para empezar con Pro',
      title: 'Tu cuenta aún \nno está activa',
      tiers: {
        text: 'Completa el pago para empezar con %{plan}.',
        title: 'Tu suscripción aún no está activa',
      },
    },
    add_items: {
      files: 'Archivos',
      folders: 'Carpetas',
    },
    complete: {
      open_panel:
        '¿<a href="/transfer/progress">Quieres saber lo que hay dentro</a>?',
    },
    details: {
      button: {
        dismiss: 'Descartar',
      },
    },
    download_preview: 'Descargar archivo',
    error: {
      expired: {
        link: 'Contacta con nuestro equipo de asistencia técnica.',
        text: '¡Ayayay! Parece ser que tu transferencia ha caducado.  \n¿Puede que sea un error?',
        title: 'Transferencia caducada',
      },
    },
    item: {
      details: {
        folder: 'Carpeta',
      },
    },
    items: {
      zero: 'vacío',
      one: '%{count} elemento',
      other: '%{count} elementos',
    },
    mobile: {
      button: {
        back: 'Volver',
        cancel: 'Volver a empezar',
        next: 'Siguiente',
      },
      email: {
        title: 'Añadir direcciones de correo electrónico',
      },
      message: {
        placeholder: 'Añadir un mensaje a tu transferencia',
        title: 'Mensaje',
      },
      options: {
        email: 'Enviar un e-mail',
        'email-description':
          'Envía tus archivos con un simple e-mail y te avisaremos en cuanto hayan sido descargados.',
        link: 'Consigue un enlace',
        'link-description':
          'Convierte tus archivos en un enlace y compártelos como más te apetezca.',
      },
    },
    recaptcha: {
      button: 'Soy 100% humano',
      text: 'Tenemos que asegurarnos de que no eres un robot (no te ofendas)',
      title: '¡Ya casi estás!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Ayúdanos',
      title: '¿Podemos preguntarte algo sobre tu forma de trabajar?',
    },
    'verification-code': 'Código de verificación',
    verify: {
      button: 'Iniciar transferencia',
      text: 'Echa un vistazo a tu cuenta de e-mail y pon aquí debajo el código de verificación que te hemos enviado.',
      title: 'Has recibido un e-mail',
      'verification-code': 'Código de verificación',
    },
    'account-verification-failed': {
      body: 'Tenemos algún problemilla para confirmar tu e-mail. Enviar otro enlace para intentarlo de nuevo.',
      cta: '¿Enviar otro enlace?',
      title: 'Algo ha salido mal',
    },
    'cookie-banner': {
      'button-accept': 'Vale',
      'button-decline': 'No gracias',
      text: 'Utilizamos <a href="%{href}">cookies</a> para el buen funcionamiento de la página web, analizar la forma en la que nuestros usuarios interactúan con ella, y poder mejorarla. ¿También quieres habilitar los cookies de terceros para poder recibir anuncios personalizados?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Utilizamos cookies analíticas para ayudarnos a entender cómo utilizas WeTransfer. Nos permiten realizar pruebas A/B de nuevas funciones, garantizar que todo funciona como debería y evitar bots y comportamientos maliciosos como el spam. Estas cookies pueden incluir cookies de terceros que procesan información personal. ',
        title: 'Cookies analíticas',
      },
      clear: {
        'clear-all-cookies': 'Eliminar todas las cookies',
        description:
          'Puede eliminar todos tus datos de nuestras cookies. Para solicitudes de anonimato permanente, ponte en contacto con <a href="mailto:support@wetransfer.com">nuestro equipo de asistencia.</a>',
        title: 'Eliminar cookies',
        warning:
          'Se cerrará tu sesión de WeTransfer después de eliminar las cookies. Esto no afectará a las transferencias de tu cuenta.',
      },
      functional: {
        description:
          'Utilizamos cookies funcionales para crear una experiencia perfecta para ti en WeTransfer. Son necesarias para utilizar nuestro Servicio.',
        title: 'Cookies funcionales',
      },
      'not-yet-set':
        'Parece que aún no nos has confirmado tu preferencia de cookies. Cierra este panel y define tus preferencias, siempre puedes cambiarlo aquí más delante.',
      'save-and-reload': 'Guardar configuración',
      tracking: {
        description:
          'Utilizamos cookies publicitarias en nuestro servicio para ayudarnos a medir el éxito de nuestros esfuerzos comerciales, editoriales y promocionales. Las cookies publicitarias no se sitúan en las páginas que ofrecen información sobre nuestra marca y productos. Las cookies publicitarias nos permiten registrar, por ejemplo, que has hecho clic en un anuncio en particular. Si las cookies situadas por terceros también se sitúan en otros dominios y sitios web, es posible que los anunciantes puedan seguir tu comportamiento a través de Internet, pero WeTransfer no puede acceder ni utilizar ninguna de esta información personal que pueda ser recopilada. Como tal, te remitimos a las políticas de privacidad de los terceros correspondientes.',
        title: 'Cookies publicitarias',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Ups, algo ha salido mal',
        'error-email-exists': 'Vaya, parece ser que este email ya está en uso.',
        'throttle-error':
          'Vaya, te hemos enviado demasiados emails. Espera %{throttle_time} antes de pedir un código nuevo.',
      },
      back: 'Volver a verificación de cuenta',
      body: '¿Hemos acertado? Esta es la dirección de email que utilizas para WeTransfer.',
      email: 'Email',
      error: 'Ups, algo ha salido mal',
      'error-email-exists':
        'Ups, parece ser que este email ya está siendo utilizado',
      submit: 'Reenviar',
      'throttle-error':
        'Disculpas, lo has intentado demasiadas veces. Intenta iniciar tu transferencia de nuevo.',
      'throttle-error-action': 'Empezar de nuevo',
      'throttle-error-link':
        'Vaya, te hemos enviado demasiados emails. Espera %{throttle_time} antes de pedir un e-mail nuevo.',
      title: 'Echa un vistazo a tu bandeja de entrada',
    },
    'email-verification-success': {
      body: 'Ahora la gente que reciba tus transferencias sabrá seguro que las has enviado tú.',
      free_signup: 'Crear cuenta gratuita',
      onboarding_body:
        'Genial, ¡todo listo! A partir de ahora la gente que reciba tus transferencias podrá estar segura de que las has enviado tú.',
      onboarding_title: '¡Bienvenido a<br/>WeTransfer Pro!',
      send_files: 'Enviar archivos',
      start_onboarding: 'Vamos a ello',
      title: '¡Tu cuenta ha sido verificada!',
      upsell: '¿No quieres tener que verificar tu email cada vez?',
      verified_sender_tooltip:
        'Tu correo electrónico está verificado, lo que hace que la gente confíe en que las transferencias las has enviado tú. Para cambiar este correo electrónico, actualiza tus <a href="%{href}">datos personales</a>.',
      verified_sender_tooltip_icon:
        'Has verificado tu dirección de correo electrónico. Esto hace que la gente confíe en que las transferencias las has enviado tú.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Vaya, el código es incorrecto o ha caducado. Códigos siguen activos durante %{expiry_time} después de haber sido enviados.',
        'error-expiry-time-action': 'Conseguir código nuevo',
        'throttle-error':
          'Has introducido un código incorrecto o caducado demasiadas veces. Espera %{throttle_time} antes de pedir un código nuevo.',
      },
      back: 'Volver',
      body: 'Hemos enviado un código de verificación a <strong title="%{account_email}">%{account_email}</strong> para asegurarnos de que eres realmente tú. (mira en tu carpeta de correo no deseado).',
      body_link:
        'Sólo falta verificar que realmente eres tú.<br/><br/>Te hemos enviado un enlace de verificación a <strong title="%{account_email}">%{account_email}</strong> (puede haber acabado en tu correo no deseado).',
      error: 'Ups, el código no es correcto o ha caducado',
      'error-expiry-time':
        'Vaya, el código es incorrecto o ha caducado. Los códigos siguen activos durante %{expiry_time} después de haber sido enviados.',
      'error-expiry-time-action': 'Conseguir código nuevo',
      resend: '¿No has recibido el email?',
      submit: 'Verificar',
      'throttle-error':
        'Disculpa, lo has intentado demasiadas veces. Intenta iniciar tu transferencia de nuevo.',
      'throttle-error-action': 'Empezar de nuevo',
      title: 'Confirmar tu e-mail',
      'verification-code': 'Código de verificación',
    },
    'force-account-verification': {
      body: 'Te enviaremos un enlace para verificar la dirección de email que utilizas con WeTransfer.',
      cta: 'Enviar email',
    },
    'marketing-email-prompt': {
      body: 'Antes de que nos olvidemos - ¿te gustaría recibir noticias acerca de WeTransfer y sus productos?',
      skip: 'No gracias',
      subscribe: 'Sí, me gustaría',
      title: '¡Verificación lista!',
    },
    'terms_conditions-no-cookies': {
      text: 'Para seguir, te rogamos que aceptes nuestros <a href="/legal/terms?from_home" data-route-type="plus">términos de servicio</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Obtén tus archivos en la aplicación WeTransfer',
      ios_banner_prompt_send: 'Envía archivos de forma rápida y sencilla',
      tnc_subtitle: 'La forma más sencilla de enviar archivos grandes',
    },
  },
  account: {
    legend: {
      plan: 'Plan',
      save: 'ahorra un %{amount}%',
      subscription: 'Suscripción',
      summary: 'Resumen del pedido',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': '¿Por qué te pedimos que confirmes tu email?',
    workspace: {
      default_workspace: 'Espacio de trabajo de %{name}',
      your_workspace: 'Tu espacio de trabajo',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Tus opciones de privacidad',
        subtitle: 'Gestiona tus datos',
        p1: 'Siempre queremos ofrecerte la mejor experiencia, incluso cuando se trata de nuestra publicidad.',
        p2: 'Nos gustaría usar los datos que decidas compartir, como tu dirección de correo electrónico, para entender qué tipo de contenido te gusta más y utilizarlo para mostrarte (a ti y a otras personas como tú) los anuncios de WeTransfer que mejor se adapten a tus necesidades.',
        p3: 'Todo lo que crees y compartas con WeTransfer seguirá siendo privado para ti: no lo leeremos ni lo utilizaremos con fines publicitarios.',
        p4: 'Si decides compartir tu información con nosotros, la mantendremos siempre protegida.',
        control_label:
          'Permite a WeTransfer usar los datos que compartas, como tu correo electrónico y tu campo de trabajo, para personalizar los anuncios que verás dentro y fuera de nuestros sitios web.',
      },
      vertical_nav: {
        terms_of_service: 'Condiciones del servicio',
        privacy_and_cookie_statement: 'Política de privacidad y cookies',
        your_privacy_choices: 'Tus opciones de privacidad',
        notice_and_takedown_policy: 'Política de notificaciones y retirada',
        responsible_disclosure_policy: 'Política de divulgación responsable',
        advertising_terms_and_conditions:
          'Términos y condiciones publicitarios',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Cerrar y enviar archivos',
  },
  account_start_screen: {
    'collect-description':
      'Guarda todo lo que te inspira en un lugar, desde tu móvil, portátil o tablet.',
    'collect-title': 'Ir a Collect',
    'paste-description':
      'Crea presentaciones preciosas en meros segundos, de forma totalmente automática.',
    'paste-title': 'Ir a Paste®',
    title: 'Tres herramientas. Una cuenta. Posibilidades infinitas.',
    'transfer-cta': 'Empecemos',
    'transfer-description':
      'Impresiona cada vez que alguien se descargue tus archivos. ¿Listo para elegir tus propios URL y fondos?',
    'transfer-title': 'Crea tu propia página WeTransfer',
  },
  account_welcome_screen: {
    'pro-title': 'Bienvenido a WeTransfer Pro, <strong>%{name}</strong>',
    accept: 'Sí, por favor',
    'accept-short': 'Vale',
    body_1:
      '¿Te gustaría estar al tanto de noticias sobre creatividad en general y novedades acerca de WeTransfer?',
    body_2: '(te podrás dar de baja cuando quieras)',
    decline: 'No, gracias',
    'decline-short': 'No gracias',
    title: '¡Bienvenido a WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Aceptar cookies',
      deny: 'Rechazar cookies',
      manage: 'Administrar cookies',
    },
    description:
      'Utilizamos cookies regulares y analíticas para garantizar una gran experiencia y cookies de terceros con fines publicitarios.',
    heading: 'Descubre la forma más sencilla de enviar archivos grandes',
    snippet: 'Bienvenido a WeTransfer',
  },
  dropzone: {
    pro: {
      title: '<span>Suelta tus archivos</span> como si quemaran',
    },
    title: "Drop it like it's hot",
    text: 'Sube tus archivos y carpetas arrastrándolos a esta ventana',
  },
  form: {
    account: {
      billing_address: 'Dirección de facturación',
      billing_cta: 'Pasar por caja',
      billing_title: 'Información de facturación',
      legend: {
        details: 'Tu información de facturación',
        coupon_code: 'Añade un código de descuento',
        free_plus: 'Obtén tu cuenta gratuita Pro',
      },
      label: {
        year_label: 'al año',
        year_sublabel: '%{discount_rate}% de descuento!',
        month_label: 'al mes',
        month_sublabel: 'Facturación recurrente',
        email: 'Dirección de correo electrónico',
        not_required: '(opcional)',
        current_password: 'Contraseña actual',
        new_password: 'Nueva contraseña',
        repeat_new_password: 'Confirmar nueva contraseña',
        password: 'Contraseña',
        password_confirm: 'Confirmar contraseña',
        full_name: 'Nombre completo',
        company: 'Empresa',
        street_and_number: 'Dirección',
        city: 'Localidad',
        zipcode: 'Código postal',
        country_code: 'País',
        vat_number: 'CIF',
        coupon_code: 'Código de descuento',
        family_name: 'Apellidos',
        given_name: 'Nombre',
        state_code: 'Estado',
      },
      description: {
        password: 'Elige una contraseña que contenga al menos 6 caracteres',
        vat_number:
          'A las empresas ubicadas en los Países Bajos les cobramos el 21 % de IVA. Si tu empresa se ubica en otro país en la UE, por favor, introduce los datos de tu empresa y tu código de identificación fiscal europeo (nº de IVA) para que así podamos eliminar el IVA de tu factura.\n \nSi tu empresa se encuentra fuera de la Unión Europrea, aún seguiremos necesitando tus datos de facturación, pero no te cobraremos el IVA.',
      },
      error: {
        email: {
          blank: 'Introduce tu dirección de correo electrónico',
          invalid: 'Introduce una dirección de correo electrónico válida',
          taken: 'La dirección de correo electrónico utilizada ya está en uso',
          taken_login:
            'Parece que ya tienes una cuenta. <a class="form-notification__message-link" href="%{login_url}">¿Iniciar sesión?</a>',
        },
        current_password: {
          invalid: 'Contraseña no reconocida',
          blank: 'Introduce tu contraseña actual',
        },
        password: {
          blank: 'Introduce tu nueva contraseña',
          too_short: 'Tu contraseña debe contener al menos 6 caracteres',
        },
        password_confirm: {
          blank: 'Por favor confirma tu nueva contraseña',
          confirm: 'Estas contraseñas no coinciden',
        },
        full_name: {
          blank: 'Introduce tu nombre completo',
          too_short: 'Ups, tu nombre debe contener 3 caracteres como mínimo',
        },
        street_and_number: {
          blank: 'Introduce tu dirección',
        },
        city: {
          blank: 'Indica tu localidad',
        },
        zipcode: {
          blank: 'Introduce tu código postal',
        },
        country_code: {
          inclusion: 'Por favor, intenta elegir de nuevo un país',
          blank: 'Introduce el nombre de tu país',
        },
        vat_number: {
          vat_number: 'Escribe un CIF válido',
        },
        terms_of_service: {
          accepted: 'Acepta nuestros Términos de servicio para continuar',
        },
        no_results: 'Por favor, intenta elegir de nuevo un país',
        convert: {
          expired:
            'Lo sentimos, pero esta transferencia ya ha caducado y, en consecuencia, no podemos guardarla. ¿Sabías que los usuarios con cuenta WeTransfer Pro pueden guardar sus transferencias durante todo el tiempo que quieran? Infórmate aquí.',
        },
        coupon_code: {
          coupon_code: 'Introduce un código de descuento válido aquí',
        },
        no_state_results: 'No hemos encontrado un estado con ese nombre.',
      },
      complete_order: 'Completa tu pedido',
      terms_conditions:
        'Acepto los <a href="/legal/terms" %{options}>Términos de servicio</a> I he leido la <a href="/legal/privacy" %{options}>Declaración de privacidad y cookies</a>',
      signup_for_plus: 'Consigue WeTransfer Pro',
      account_cta: 'Adelante',
      signup_for_account: 'Crea una cuenta WeTransfer',
      'email-verification-not-verified-link':
        'Verifica tu dirección de email por favor. Echa un vistazo al email que te hemos enviado o pulsa <button type="button" class="button button--link"> para recibir uno nuevo</button>.',
      'email-verification-resend': {
        error: 'Ups, algo ha salido mal',
        info: '¡Código nuevo enviado! Echa un vistazo a tu bandeja de entrada',
        info_link:
          '¡Te hemos enviado otro email! Echa un vistazo a tu bandeja de entrada',
        'throttle-error':
          'Vaya, te hemos enviado demasiados emails. Espera %{throttle_time} antes de pedir un código nuevo.',
      },
      'force-account-verification': {
        message:
          'Por favor, verifica tu dirección de email para comprobar que realmente eres quien dices ser.',
      },
      marketing_opt_in:
        'Me gustaría recibir noticias acerca de WeTransfer y sus productos',
      sso: {
        header: 'Información personal',
        password_reset: {
          button: 'Enviar email',
          instructions:
            '¿Necesitas un pequeño cambio (de contraseña)? No hay problema. Dale al botón de abajo y te enviaremos un email a <span>%{email}</span> con un enlace para cambiar tu contraseña.',
          success: '¡Email enviado! Mira tu bandeja de entrada.',
          title: 'Cambiar contraseña',
        },
        wrong_user: '¿No eres tú? Salir',
      },
    },
    payment_cancel: {
      submit: 'Confirmar',
      client_request:
        'Un cliente me pidió utilizar WeTransfer y ahora ya no me hace falta',
      different_tool: 'He encontrado otra herramienta',
      extra_features: 'Necesito otras funcionalidades que no me ofrece',
      not_enough_storage:
        'El servicio no me ofrece suficiente capacidad de almacenamiento',
      not_often_large_files: 'No envío archivos grandes con frecuencia',
      other: 'Otra razón',
      other_more: '¿Nos puedes contar algo más al respecto?',
      skip: 'Omitir y anular suscripción',
      temp_project:
        'Solamente necesitaba enviar archivos grandes para un proyecto en concreto',
      too_expensive: 'Creo que cuesta demasiado',
    },
    payment_cancel_reason: {
      skip: 'No quiero realizar comentarios',
    },
    profile: {
      label: {
        profile_title: 'Nombre del perfil',
        wallpaper_link: 'Dirección web a la que enlazar los fondos de pantalla',
      },
      error: {
        subdomain_name: {
          too_short:
            'Tu URL de WeTransfer necesita contener al menos dos caracteres',
          domain_name: 'Lo sentimos, alguien ya escogió este nombre de usuario',
          invalid:
            'Uff, ¡demasiado complicado! Tu URL de WeTransfer sólo puede contener letras y números (y un guión entremedio)',
          taken: 'Lo sentimos, alguien ya escogió este nombre de usuario',
        },
        subdomain: {
          too_short: 'Continúa hasta al menos 2 caracteres',
          too_long: 'Ufff, que sean menos de 63 caracteres',
          invalid:
            'Uff, ¡demasiado complicado! Tu URL de WeTransfer solo puede contener letras y números (y un guion entremedio)',
          domain_name: 'Esta URL ya está en uso',
          taken: 'Esta URL ya está en uso',
        },
        default_recipient_email: {
          invalid: 'Introduce una dirección de correo electrónico válida',
        },
        wallpaper_link: {
          invalid: 'Introduce una dirección web válida',
        },
      },
      success: {
        subdomain: {
          updated: 'Tu URL se ha actualizado',
          available: 'Buenas noticias, esta URL está disponible',
        },
      },
      change_background: 'Subir fondo',
      delete_avatar: 'Eliminar avatar',
      delete_background: 'Eliminar fondo',
      description: {
        title:
          'Ojo, utiliza 150 caracteres como mucho para que quepa en pantalla',
        wallpaper_link: 'Tus fondos de pantalla enlazarán a esta dirección web',
        recipient_email_locked:
          'Los archivos enviados a través de tu perfil solo irán a esta dirección de email',
      },
      upload_avatar: 'Subir avatar',
      use_email_background_checkbox_label:
        'Usar este fondo de pantalla para todas las transferencias enviadas a través de mi perfil',
      account_email_checkbox: 'Mostrar email en perfil',
      default_recipient_email_info:
        'Puedes cambiar esta dirección email en tus <a href="/account">datos personales</a>',
      change_subdomain: {
        message:
          '¿Cambiar la URL a <a href="%{url}">%{subdomain}.wetransfer.com</a>? La anterior quedará disponible inmediatamente.',
        confirm: 'Sí, cambiar la URL',
        cancel: 'Volver',
      },
    },
    fill_in_password: 'introduce tu contraseña para guardar estos cambios',
    select_all: 'Seleccionarlo todo',
    deselect_all: 'Anular selección',
    save_changes: 'Guardar cambios',
    save: 'Guardar',
    submitting: 'Procesando…',
    cancel: 'Cancelar',
    forward: 'Reenviar',
    proceed: 'Continuar',
    delete: 'Eliminar',
    onboarding: {
      placeholder: {
        subdomain_name: 'elige-un-nombre-acertado',
      },
      validated: {
        subdomain_name: '¡Buenas noticias! Este dominio está disponible.',
      },
    },
    confirm_leave:
      '¿Estás seguro de que quieres abandonar esta página y perder los cambios no guardados?',
    unsaved_changes: '¿Abandonar página? Perderás los cambios no guardados.',
    contact: {
      add_contact: 'Añadir contacto',
      error: {
        email: {
          duplicate:
            'Esta dirección de correo electrónico ya está en tu lista de contactos',
          invalid: 'Escribe una dirección de correo electrónico válida',
        },
      },
      label: {
        company: 'Empresa',
        email: 'E-mail',
        name: 'Nombre',
      },
    },
    error: {
      current_password: {
        blank: 'Escribe tu contraseña actual',
        invalid: 'Contraseña no reconocida',
      },
      email: {
        blank: 'Escribe tu dirección de correo electrónico',
        duplicate:
          'Esta dirección de correo electrónico ya está en tu lista de contactos',
        invalid: 'Escribe una dirección de correo electrónico válida',
        taken: 'La dirección de correo electrónico utilizada ya está en uso',
      },
    },
    leave: 'Salir',
    resetpassword: {
      button: {
        request_submit: 'Enviar',
        reset_submit: 'Guardar nueva contraseña',
      },
      label: {
        confirm_new_password: 'Confirmar nueva contraseña',
        email: 'Dirección de correo electrónico',
        new_password: 'Nueva contraseña',
      },
      legend: {
        request_description:
          '¿No puedes entrar? Te enviaremos instrucciones sobre cómo reiniciar tu contraseña.',
        request_title: '¿Olvidaste tu contraseña?',
        reset_description:
          'Introduce una nueva contraseña para volver a acceder',
        reset_title: 'Define una nueva contraseña',
        request_description_success_or_article:
          '¡Tienes un email! Sigue las instrucciones que te acabamos de enviar o echa un vistazo a <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">este artículo</a> en nuestro centro de ayuda si no recibes algo en los próximos minutos.',
      },
    },
    signin: {
      button: {
        submit: 'Entrar',
      },
      label: {
        email: 'Dirección de correo electrónico',
        password: 'Contraseña',
        remember_me: 'Recordar mis datos',
      },
      link: {
        forgot_password: '¿Olvidaste la contraseña?',
      },
      title: 'Iniciar sesión',
    },
    stay_on_page: 'Permanecer en la página',
    close_panel: 'Cerrar',
    go_back: 'Volver',
    labels: {
      email: 'E-mail',
    },
    plan: {
      change: {
        month: 'Mensual (%{price} %{currency})',
        title: 'Cambiar suscripción',
        year: 'Anual (%{price} %{currency})',
      },
      change_plan: 'Cambiar periodicidad de pago',
      month: {
        copy: 'Facturación recurrente',
        label: 'Al mes',
        'label-payment': 'Pago mensual',
        'sub-label': 'Una factura cada mes',
        title: 'WeTransfer Pro: Pago mensual',
      },
      title: 'Dale a tus ideas el tratamiento premium que se merecen',
      year: {
        discount: 'Ahorra un %{rate} % (¡¡síí!!)',
        'label-payment': 'Pago anual',
        'sub-label': 'Un ahorro del 17 %. ¡Toma ya!',
        title: 'WeTransfer Pro: Pago anual',
      },
      your_order: 'Tu pedido',
    },
    save_and_continue: 'Guardar y continuar',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Introduce tu contraseña para seguir',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Ahora no',
        true: 'Abrir en la app WeTransfer',
      },
      headline: '¿Por qué no pensar a lo grande?',
      headline2: '¿Quieres ver los archivos en la app?',
      subheader: 'Envía y recibe 200 GB con WeTransfer Pro',
      subheader2:
        'Mira los archivos antes de descargarlos. Envía y recibe transferencias, haz un seguimiento de las descargas y recibe notificaciones.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Renueva ahora para seguir disfrutando de todas las ventajas de tu cuenta %{tier}',
      account_expired_title_tier: 'Tu cuenta %{tier} ha caducado',
      account_inactive_title_tier: '¿Todo listo para hacerte %{tier}?',
      account_inactive_action: 'Sí, continuar',
      account_inactive_subtitle:
        'Sólo un paso más y ya está. ¿Te lo has pensado mejor? No pasa nada—',
      account_inactive_title: '¿Estás listo para una experiencia Pro?',
      account_subscription_action: 'Renovar ahora',
      account_subscription_expired: 'Tu cuenta Pro ha caducado',
      account_subscription_subtitle:
        'Renuévala ahora para conservar tus transferencias, tus fondos de pantalla personales y tu dirección web. Si no lo haces, ¡se borrará en breve!',
      account_expired_action: 'Renuévala ahora',
      account_expired_subtitle:
        'Renueva ahora tu suscripción para seguir disfrutando de todos los beneficios de tu cuenta Pro',
      account_expired_title: 'Tu cuenta Pro ha caducado',
      expired_transfer_subtitle:
        'Los archivos ya no están disponibles. Para borrar esta información de tu resumen de transferencias, pulsa <a>aquí</a>.',
      expired_transfer_title: 'Esta transferencia ha caducado',
      account_email_verify_logged_out: 'Inicia sesión para verificar tu email',
      account_inactive_sublink: 'cancela tu pedido.',
      email_unverified_mobile_cta: 'Listo para verificar',
      email_unverified_text:
        "Hemos enviado un código de verificación a %{email}. <a href='%{href}'>¿No eres tú?</a>",
      email_unverified_text_link:
        "Te hemos enviado un email a %{email}. <a href='%{href}'>¿No eres tú?</a>",
      email_unverified_title: 'Verifica tu email por favor',
      'force-account-verification': {
        body: 'Te enviaremos un enlace por email para verificar que realmente eres tú.',
      },
      'receiving-email':
        '¡Importante! Hemos reemplazado %{receiving_email} en tu perfil. Esto significa que nuevas transferencias, únicamente aparecerán en tu resumen de transferencias si han sido enviadas a %{account_email}. Para cambiarlo, puedes actualizar tus <a href="/account">datos personales</a> en cualquier momento.',
    },
    design:
      'Probablemente has notado que hemos hecho algunos cambios. Muchos están relacionados con cosas que nos has dicho que querías ver. Así que esperamos disfrutes explorando el nuevo y (nos atreveríamos a decir) mejorado sitio web. Y por favor, si tienes algún comentario, no dudes en hacérnoslo llegar desde aquí.',
    loading_error:
      'Vaya, parece que esta página tiene problemas para cargarse en este momento. \nSeguiremos intentándolo aunque también puedes intentar <a href="%{path}">refrescarla</a> por ti mismo.',
    redesign_notice:
      'Probablemente hayas notado que <a href="/about/redesign">hemos hecho unos pequeños cambios</a> por aquí. La mayoría son cosas que nos habías pedido, así que disfruta descubriendo las novedades y nuestro (nos atravemos a decir) mejor sitio web hasta le fecha. Y por supuesto, si tienes algún comentario, <a href="/contact" rel="external">envíanoslo por aquí<a/>.',
    return_to: 'volver a %{pageName}',
    close: 'Cerrar ventana',
    cookie: {
      accept: 'Vale',
      text: 'Utilizamos cookies. Echa un vistazo a la <a href="/legal/terms">info legal</a> (no incluye recetas).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Empleo',
      press: 'Prensa',
      terms: 'Info legal',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Mejorar suscripción',
    free_limit:
      'No puedes enviar más de 2 GB de una vez. ¿Quieres enviar transferencias más grandes?',
    compare_plans: {
      button: 'Comparar planes',
      text: 'Puedes actualizar tu plan para transferir más de 2 GB de una vez.',
      title: '¿Tiene más archivos que enviar?',
    },
    mobile: {
      cta: 'Leer más',
      header: 'Aprovecha WeTransfer al máximo',
      upsell_enjoy: 'Obtén más espacio de almacenamiento',
      upsell_one: 'Envía transferencias más grandes',
      upsell_two: 'Personaliza tu página de WeTransfer',
    },
    pro_limit:
      'No puedes enviar más de 200 GB de una vez. ¿Quieres enviar transferencias de cualquier tamaño?',
  },
  upsell_tiers_one: {
    text: '¿Quieres poner contraseña y fecha de caducidad a tus transferencias?',
  },
  upsell_tiers_three: {
    text: '¿Quieres enviar transferencias a más de %{email_limit} direcciones de email a la vez?',
    title: 'Aquí hay algo de más',
  },
  browser: {
    assets_failed: {
      text: 'No pudimos cargar algunas partes importantes de nuestro sitio web. Puede que hayan sido bloqueadas por tu cortafuegos, servidor proxy o configuración del navegador. Intenta volver a cargar la página o ponte en contacto con nosotros a través del <a href="https://wetransfer.zendesk.com" rel="external">centro de ayuda</a>.',
      title: '¡Ay, no!',
    },
    javascript_needed:
      'Necesitas un navegador que permita el uso de JavaScript para poder usar WeTransfer',
  },
  languages: {
    en: 'Inglés',
    nl: 'Países Bajos',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Esta oferta está disponible hasta el %{end_date}. El descuento se aplica el primer año de %{user_tier}, después del cual la suscripción se renovará por un total de %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount} % de descuento en Pro anual',
      subtitle: 'Código de descuento: %{coupon_code_name}',
      text_content:
        'Eso es todo. No hay trampa ni cartón. Te ofrecemos un descuento del %{discount_amount} % en tu plan Pro anual.',
      argument: {
        size_limit: 'Envía y recibe transferencias de archivos de 200 GB',
        storage_size: 'Disfruta de 1 TB de almacenamiento',
        unlimited_review: 'Crea revisiones ilimitadas',
      },
      cta_label: 'Reclamar descuento',
      dismiss_label: 'Ahora no',
    },
    banner: {
      title:
        'Consigue un %{discount_amount} % de descuento en WeTransfer Pro durante un año: nuestra mejor oferta hasta ahora',
      cta_label: 'Actualizar',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title:
        'Trabaja en equipo con transferencias con %{first_recipient_email}',
      subtitle:
        'Invita a tu equipo a enviar y recibir transferencias con tu plan %{user_plan}.',
      list: {
        overview_item: 'Resumen compartido de las transferencias',
        storage_limit_item:
          'Almacenamiento compartido de %{storage_limit} adicional por persona',
        branding_item: 'Branding de equipo compartido',
        subscription_item: 'Suscripción y facturación compartidas',
      },
      cta: 'Invitar equipo',
      dismiss_button: 'Hoy no',
    },
    second_viewing: {
      title:
        'Trabaja en equipo con transferencias con ${first_recipient_email}',
      subtitle:
        'Invita a tu equipo a enviar y recibir transferencias con tu plan %{user_plan}.',
      list: {
        overview_item: 'Resumen compartido de las transferencias',
        storage_limit_item:
          'Almacenamiento compartido de %{storage_limit} adicional por persona',
        branding_item: 'Branding de equipo compartido',
        subscription_item: 'Suscripción y facturación compartidas',
      },
      cta: 'Invitar equipo',
      dismiss_button: 'Ocultar para siempre',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Tu cuenta ha sido actualizada',
    update_password: 'Tu contraseña ha sido actualizada',
    update_subscription: 'Tu plan de pagos ha sido actualizado',
    update_profile_success: 'Tu perfil ha sido actualizado',
    link_copied: 'Este enlace ha sido copiado a tu portapapeles',
    copy_link_manual: 'Enlace seleccionado, cópialo usando %{shortcut}',
    delete_transfer_success: 'Esta transferencia ha sido eliminada',
    delete_transfers_success: 'Las transferencias han sido eliminadas',
    update_expiry_success: 'La fecha de caducidad ha sido actualizada',
    onboarding_success:
      'Pasa por aquí para ver tus transferencias, contactos, perfil y otras cosillas',
    add_contact_success: 'Este contacto ha sido añadido',
    edit_contact_success: 'Este contacto ha sido actualizado',
    remove_contact_success: 'Este contacto ha sido eliminado',
    already_signed_in: 'Sesión iniciada',
    cancel_subscription_success:
      'Nos da pena que te vayas: tu suscripción ha sido cancelada.',
    collect_app_banner_desc:
      'Previsualizar, guardar y manejar archivos de la aplicación Collect',
    contact_added_confirmation: 'El contacto se añadió a tu transferencia',
    contact_recipient_locked_text:
      'Esta página sirve para que el propietario reciba archivos. ¿Quieres enviar archivos a otra persona?',
    forward_ready: 'Tu transferencia está lista para ser reenviada',
    mobile_app_banner_desc: 'Previsualiza, guarda y organiza con la app',
    mobile_app_banner_title: 'Guárdalo en la app',
    reactivate_subscription_success:
      '¡Bienvenido/a de vuelta! Tu cuenta ha sido reactivada. ',
    refresh_transfer_upload_lost:
      '¿Estás seguro de querer cancelar la subida actual?',
    update_payment_success:
      'Tus datos de pago han sido actualizados correctamente. ¡Tachán!',
    update_user: 'Se han actualizado tus datos',
    current_team_notification: 'Estás utilizando %{plan} como %{currentTeam}',
    display_name_updated: '¡Título actualizado!',
    download_started:
      'Tu descarga ha comenzado Una vez finalizada, los archivos estarán en tu ordenador (generalmente, en la carpeta de descargas)',
    logged_out:
      'Parece ser que tu sesión ha sido anulada desde otro navegador. Vuelve a iniciar sesión.',
    project_delete:
      '¿Eliminar <strong>%{projectName}</strong> y cualquier archivo que hayas añadido?',
    project_delete_success: '<strong>%{projectName}</strong> se ha eliminado',
    password_changed: 'Contraseña cambiada',
    password_removed: 'Contraseña eliminada',
  },
  alert: {
    confirm_cancel_upload_image:
      '¿Estás seguro de querer cancelar la subida actual? ',
    cancel_recipient_locked: 'Anular',
    cancel_refresh_transfer_upload_lost: 'No',
    confirm_refresh_transfer_upload_lost: 'Sí',
    go_to_transfer: 'Ir a transferencia',
    redirect_recipient_locked: 'Sí',
    stay: 'Permanecer',
    cancel_project_delete: 'Cancelar',
    confirm_project_delete: 'Eliminar',
  },
  force_update:
    '¡Te esperan grandes emociones! <a href="/" onClick=\'javascript:window.location.reload();\'>Refresca tu navegador</a> para asegurarte que estás usando la versión más reciente de WeTransfer',
  user: {
    already_logged_in:
      'Ya has iniciado sesión, ¿estás seguro de querer reiniciar tu contraseña?',
    roles: {
      admin: 'administrador',
      owner: 'propietario',
      user: 'usuario',
    },
    sign_out_and_reset: 'Cerrar sesión y restablecer contraseña',
  },
  click_here: 'Haz clic aquí',
  cookiebox: {
    notice:
      '<bold>Has iniciado sesión</bold>, se cerrará tu sesión después de eliminar las cookies. Las transferencias anteriores en tu cuenta no se verán afectadas.',
  },
  notice: {
    general_issues:
      '¿Hay algo que no funciona como toca? Sabemos que es frustrante, pero prometemos solucionarlo <a target="_blank" href=%{link}>lo antes posible</a>',
    transfer_issues:
      '¿Tienes problemas con tu transferencia? Sabemos que es frustrante, pero prometemos solucionarlo <a target="_blank" href=%{link}>lo antes posible</a>',
    verification: 'Ey, necesitamos <a href="/account">confirmar tu email</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Acerca de | WeTransfer',
      advertise: 'Anúnciate con nosotros | WeTransfer',
      apps: 'Aplicaciones gratuitas para Mac, iOS y Android | Apps WeTransfer',
      forgot_password: 'Restaurar contraseña | WeTransfer Pro',
      help: 'Cómo enviar archivos grandes | Ayuda WeTransfer',
      home: 'Comparte archivos grandes de forma cómoda y gratuita | WeTransfer',
      plus: 'Date de alta para enviar archivos de mayor tamaño | WeTransfer Pro',
      sign_in: 'Iniciar sesión | WeTransfer Pro',
      sign_up: 'Alta | WeTransfer Pro',
      upgrade: 'Contratar | WeTransfer Pro',
      pricing:
        'Precios | WeTransfer - Envía archivos grandes y comparte fotos por internet - Hasta 2 GB gratis',
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: '¿Aún no has encontrado lo que buscabas?',
    },
  },
  splash: {
    footer: {
      or: 'o',
      send_files: 'Solo quiero enviar archivos',
      no_thanks: 'No gracias',
    },
    heading: {
      line_1_free: 'WeTransfer es la mejor forma de enviar archivos grandes',
      line_2_free: 'Sácale más partido a WeTransfer',
      free_account: 'Bienvenido de vuelta. ¿Lo hacemos oficial?',
    },
    plan: {
      plus: {
        feature_10: 'Personaliza tus e-mails',
        feature_11: 'Almacena hasta %{plus_storage_limit}',
        feature_12: 'Configura cuando caducarán tus transferencias',
        feature_13: 'Protege tus transferencias con contraseña',
        feature_7: 'Personaliza tu perfil',
        feature_8: 'Crea tu propia lista de contactos',
        feature_9: 'Personaliza tu URL de WeTransfer',
      },
      free_account: {
        cta: 'Darte de alta gratuitamente',
        feature_1: 'Sin almacenamiento',
        feature_2: 'Envía hasta %{free_transfer_limit}',
        feature_3: 'Reenvia y elimina transferencias',
        heading: 'Cuenta WeTransfer',
        price_label: 'Gratis para siempre',
      },
      pro: {
        cta: 'Consigue WeTransfer Pro',
        feature_1: '%{storage_limit_pro} de almacenamiento',
        feature_2: 'Envía y recibe hasta %{transfer_limit_pro}',
        feature_2_unlimited: 'Envía y recibe archivos sin límites de tamaño',
        feature_3: 'Reenvia y elimina transferencias',
        feature_4: 'Protege tus transferencias con contraseña',
        feature_5: 'Tu página y URL Pro personal',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: '¿Quieres añadir a %{recipient} a tu equipo?',
      text_content:
        'Los miembros del equipo pueden acceder a las transferencias de los demás con almacenamiento y branding compartidos. Esto no cancelará tu transferencia.',
      cta: 'Adelante',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Enlace copiado',
      copy: 'Copiar enlace',
      copy_again: 'Copiar de nuevo',
    },
    labels: {
      share: 'Compartir esta transferencia',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'CONSEJO PRO',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Quiero probar portals',
        dismiss: 'Ahora no',
        text: 'Puedes invitar a clientes y colaboradores a que echen un vistazo a tu trabajo y que elijan sus favoritos en <strong>portals</strong>. Cuanto menos emails de aquí para allá, mejor.',
        title: '¿Necesitas la opinión de alguien sobre tu trabajo—rápidamente?',
      },
      'second-viewing': {
        cta: 'Quiero probar portals',
        dismiss: 'No volver a mostrar',
        text: 'Recibe feedback rápidamente y comparte versiones nuevas—todo desde un mismo lugar. Con <strong>portals</strong>, te podrás asegurar de que el proceso de evaluación, revisión y versión final acabe siendo rápido y conciso.',
        title: 'Has enviado tu trabajo. ¿Y ahora qué?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Ir a Branding',
        text_2: '¿Quieres añadir tus propios vídeos e imágenes?',
      },
      individual: {
        cta: 'Personalizar mi página',
        text: 'Impresiona a la gente que se descargue tus archivos. Añade vídeos o imágenes y elige tu propia URL.',
        title: 'Impresiona con tu página WeTransfer personalizada',
      },
      invitee: {
        cta: 'Entendido',
        text_1:
          'Gracias a la página de WeTransfer personalizada de tu equipo, dejarás una impresión perfecta cada vez que compartas tu trabajo.',
        text_2:
          'Puedes cambiar los fondos de tu equipo en cualquier momento a través de <strong>Branding</strong>.',
        title: 'Impresiona con tu trabajo (en equipo)',
      },
      not_now: 'Ahora no',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Configurar página',
                  premium: {
                    text: 'Cualquiera te podrá enviar transferencias de cualquier tamaño desde la página WeTransfer de tu equipo.',
                  },
                  text: 'Cualquiera te podrá enviar %{transfer_limit_pro} en transferencias desde la página WeTransfer de tu equipo.',
                },
                premium: {
                  transfer_link: {
                    text: 'Cualquiera te podrá enviar transferencias de cualquier tamaño desde %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Cualquiera te podrá enviar %{transfer_limit_pro} en transferencias desde %{custom_link}',
                },
              },
              premium: {
                text: 'Cualquiera te podrá enviar transferencias de cualquier tamaño desde la página WeTransfer de tu equipo. Solo tienes que darles este enlace.',
              },
              regular: {
                cta: 'Entendido',
                text: 'Cualquier persona te podrá enviar <strong>%{transfer_limit_pro}</strong> en transferencias desde la página WeTransfer de tu equipo. Pásale este enlace y ya está.',
                title: 'Todo lo que recibe tu equipo, resumido en un lugar',
              },
            },
            sent: {
              regular: {
                cta: 'Entendido',
                text: 'Bienvenido al resumen compartido de transferencias de tu equipo. Desde aquí podrás seguir descargas, cambiar fechas de caducidad e incluso editar o cancelar las transferencias de otra persona, ¡aunque sería una buena idea avisarle de antemano!',
                title: 'Gestiona las transferencias de tu equipo',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus ahora se llama WeTransfer Pro con 1 TB de espacio — 10x más que antes. <a href="/transfers">Cuéntame más.</a>',
  },
  refer_friend: {
    title: 'Recomienda a amigos',
    account: {
      description:
        'Os daremos 10 USD a ti y a un amigo cuando se registre en WeTransfer Pro o Premium. Comparte tu enlace de recomendación para obtener una recompensa en tarjetas prepago, donaciones benéficas o tarjetas regalo de cientos de socios.',
    },
    window: {
      link: 'Obtener el enlace de recomendación',
      send_another: 'Continuar',
      text: 'Os daremos <strong>10 USD</strong> a ti y a un amigo cuando se registre en WeTransfer Pro o Premium.',
      title: 'Recomiéndanos a un amigo',
      title_2: 'para enviar transferencias.',
    },
    message: {
      success:
        '¡Aquí tienes a un gran amigo! Inscríbete en WeTransfer Pro o Premium y cada uno recibirá una tarjeta prepago, una donación benéfica o una tarjeta regalo por valor de 10 USD.',
      self: 'Ay, no, parece que ese enlace de recomendación no funciona. Pídele a tu amigo un nuevo enlace para recibir 10 USD al registrarte en WeTransfer Pro o Premium.',
      fallback:
        'Ay, no, parece que ese enlace de recomendación no funciona. Pídele a tu amigo un nuevo enlace para recibir 10 USD al registrarte en WeTransfer Pro o Premium.',
      expired: 'Lo sentimos, tu enlace de recomendación ha caducado.',
      dismiss: 'Descartar',
    },
  },
  order_summary: {
    coupon: {
      link: 'Aplicar código promocional',
      input_placeholder: 'Código promocional',
      button_label: 'Aplicar',
      error_message:
        'Lo sentimos, pero este código solo se puede usar para ahorrar en una suscripción a %{billing_period}.',
      generic_error_message:
        'Lo sentimos, el código no es compatible con esta suscripción',
      input_error_message: 'Vaya, este código no es válido.',
      pill_label: {
        percentage: '-%{percentage} %',
      },
    },
    total: 'Total',
  },
  mobile_verify: {
    title: '¡Todo listo!',
    subtitle:
      'Tu correo electrónico ha sido verificado: ahora puedes usar la app para enviar y recibir transferencias.',
    cta: 'Abre la app WeTransfer',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Tu plan actual de <b>%{formattedintervaltotal}</b>/%{subscriptioninterval} se renovará automáticamente el <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Tu plan actual de <b>%{formattedTeamWorkspaceCost}</b>/%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) se renovará automáticamente el <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Tu próxima fecha de pago es el <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b>/%{interval}',
    team_upgrade_calculation: '(%{membercount} miembros x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Transferencias sin límite de tamaño',
    premium_feature_two: 'Almacenamiento ilimitado',
    premium_feature_three: 'Portales y revisiones ilimitadas',
    premium_feature_four:
      'Ver <a class="all-benefits-link" href="%{all_benefits_href}">todas las ventajas</a>',
    premium_switch_cta_text: 'Cambiar a Premium',
    pill_text: 'Plan actual',
    member_count: '%{membercount} miembros',
    see_all_benefits: 'Ver todas las ventajas del plan',
    pending_downgrade_current_subscription:
      'La suscripción a tu espacio de trabajo se ha cancelado y finalizará el <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      '¿Has cambiado de idea? No te preocupes, es fácil volver a poner las cosas en marcha.',
    pending_downgrade_reactivate_cta: 'Reactivar Pro',
    pending_downgrade_payment: 'No tienes pagos pendientes',
    update_payment_cta: 'Actualizar datos de pago',
    cancel_plan:
      'Si cancelas tu suscripción, podrás acceder a tu espacio de trabajo %{planName} hasta el %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Tu espacio de trabajo bajará de categoría al plan gratuito y tus transferencias existentes caducarán en un plazo de 28 días.',
    pending_payment_text:
      'Para ver tu plan y la información de pago, completa el pago o cancela tu pedido.',
    learn_more: 'Más información sobre planes y precios',
  },
  time: {
    days: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    months: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
    },
    remaining: {
      minutes: {
        zero: 'Menos de un minuto para terminar',
        one: 'Alrededor de 1 minuto para terminar',
        other: 'Alrededor de %{count} minutos restantes',
      },
      hours: {
        one: 'Alrededor de 1 hora restante',
        other: 'Alrededor de %{count} horas restantes',
      },
    },
  },
  download: {
    shortcut: 'Presiona %{command} para ver la<br />progresión de la descarga',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Enviar hasta %{size}',
    progress: {
      busy: 'Transfiriendo...',
    },
    buttons: {
      add: 'Añadir archivos',
      transfer: 'Transferencia',
      forward: 'Reenviar',
      add_ios6: 'Añade fotos y vídeos',
      add_ios7: 'Añade fotos',
    },
    forward: {
      done: 'Reenvío completo',
    },
    friend_email: {
      title: 'Email de tu amigo',
      more: 'Añadir más amigos',
    },
    your_email: {
      title: 'Tu email',
    },
    message: {
      title: 'Mensaje',
    },
    done: {
      title: 'Transferencia completa',
      link: 'Copiar tu enlace de descarga:',
      copied: {
        title: '¡Copiado!',
        text: 'Se ha copiado el enlace de descarga.',
      },
    },
    more_html: 'Añadir más archivos<span>(%{size})</span>',
    too_many_recipients:
      'Parece que has introducido demasiadas direcciones. Recuerda: hay espacio para un máximo de %{count} personas a la vez.',
    completed: '%{size} de %{total} completado',
    addresses: {
      one: '%{count} dirección',
      other: '%{count} direcciones',
      remove: '¿Quieres eliminar %{address} de tus anteriores destinatarios?',
    },
    ads: {
      plus: {
        title: '¡Sácale más partido<br />a WeTransfer</br>Pro!',
        text: "<ul><li>Sube archivos enormes</li><li>Transferencias personalizadas con tu propio fondo de pantalla</li><li>Transferencias protegidas con contraseña</li><li>Almacenamiento a largo plazo</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Más detalles</a></p>",
      },
      plus2: {
        title: 'Impresiona<br />con tu<br />propia página de descargas',
        text: "<p>Utiliza tus propios fondos de pantalla y dirección de WeTransfer personalizada (tunombre.wetransfer.com) e impresiona a los destinatarios de tus envíos.</p><p><a target='_blank' href='/pro?trk=inapp'>Más detalles</a></p>",
      },
      plus3: {
        title: 'Gestiona tus transferencias de forma más inteligente',
        text: "<p>Este envío se eliminará después de 1 semana, pero con WeTransfer Pro puedes almacenar los envíos indefinidamente, o reenviarlos y eliminarlos instantáneamente sin necesidad de tener que volver a subirlos.</p><p><a target='_blank' href='/pro?trk=inapp'>Más detalles</a></p>",
      },
      plus4: {
        title: 'Consigue una protección adicional para tus archivos',
        text: "<p>Con WeTransfer Pro, puedes proteger tus archivos confidenciales con una clave.</p><p>De esa forma, no caerán en manos equivocadas.</p><p><a target='_blank' href='/pro?trk=inapp'>Más detalles</a></p>",
      },
      facebook: {
        title: 'Únete a la comunidad WeTransfer en Facebook',
        text: "<p>Entérate de las últimas novedades, gana premios, descubre nuevos artistas, lee entrevistas y mucho más.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Más detalles</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        'Lo sentimos, solo se admite email cuando se reenvía una transferencia.',
      connect_twitter:
        'Tu cuenta de Twitter aún no está vinculada a WeTransfer.',
      connect_facebook:
        'Tu cuenta de Facebook aún no está vinculada a WeTransfer.',
      transferproblems: {
        title: 'Problema de transferencia',
        text: 'Sentimos decirte esto, pero algo ha ido mal con la transferencia.',
      },
      limitreached: {
        title: 'Límite de almacenamiento',
        text: 'Has alcanzado tu límite de 1 TB. Borra algunas transferencias antiguas para enviar archivos nuevos',
      },
      blocked: {
        title: 'Problema de transferencia',
        text: 'El ordenador no responde. Lo sentimos, has sido bloqueado de WeTransfer.',
      },
      upload_error: {
        title: 'Problema de transferencia',
        text: 'Sentimos decirte esto pero, algo ha ido mal con la transferencia.',
      },
      unavailable: {
        title: 'Error de transferencia',
        text: 'Lo sentimos, esta transferencia ya ha sido borrada por lo que no puede ser reenviada.',
      },
      startswithdot: {
        title: '¡Uy!',
        text: 'Uno (o más) de tus archivos tiene un nombre que empieza por un punto. No va a funcionar. Dale un nombre nuevo al archivo(s) y vuelve a intentarlo.',
      },
      startswithspace: {
        title: '¡Uy!',
        text: 'Uno (o más) de tus archivos tiene un nombre que empieza por un espacio. No va a funcionar. Dale un nombre nuevo al archivo(s) y vuelve a intentarlo.',
      },
      containsreturn: {
        title: '¡Uy!',
        text: 'Uno (o más) de tus archivos tiene un nombre que contiene la tecla retorno. No sabemos cómo has hecho esto, pero no va a funcionar. Dale un nombre nuevo al archivo(s) y vuelve a intentarlo.',
      },
      alreadyinlist: {
        title: '¡Ostras!',
        text: 'Uno de tus archivos tenía el mismo nombre que otro archivo que ya habías seleccionado. ¡Cámbialo un poquito!',
      },
      transfertoobig: {
        title: '¡Ay no!',
        text: 'Lo sentimos mucho pero no podemos transferir más de %{upload_limit}GB de una vez.',
      },
      filetoobig: {
        title: '¡Ay no!',
        text: 'Lo sentimos mucho pero no podemos transferir más de %{upload_limit}GB de una vez.',
      },
      zerobytes: {
        title: '¡Vaya!',
        text: 'Uno (o más) de tus archivos está vacío o no se pudo leer.',
      },
      ioerror: {
        title: 'Fallo',
        text: 'Uno (o más) de tus archivos no se ha podido leer o es mayor de %{upload_limit}GB. La cosa no va a ir bien.',
      },
      filenametoolong: {
        title: '¡Ostras!',
        text: 'Uno (o más) de tus archivos contiene un nombre superior a 250 caracteres. No podemos aceptar nombres que superen los 250 caracteres, así que dale un nombre nuevo, por favor.',
      },
      nofolders: {
        title: '¡Ay no!',
        text: 'Lo sentimos, todavía no es posible subir carpetas. Intenta comprimirla en un archivo .zip primero.',
      },
      nofiles: {
        title: '¡Uy!',
        text: 'No has añadido ningún archivo todavía.',
      },
      norecipients: {
        title: '¡Vaya!',
        text: 'Parece que se te ha olvidado añadir las direcciones de email a las que mandarlo.',
      },
      toomanyrecipients: {
        title: '¡Ostras!',
        text: 'Demasiados destinatarios.',
      },
      bigmessage: {
        title: '¡Caray!',
        text: 'Su mensaje es más largo que un día sin pan. Acórtelo.',
      },
      nosender: {
        title: '¿En serio?',
        text: 'Se te ha olvidado introducir tu propio email. ¿Cómo has podido?',
      },
      senderemailinvalidformat: {
        title: '¡Ay no!',
        text: 'Tu dirección parece ser incorrecta. ¡Cuidado con la ortografía!',
      },
      probablynotcopied: {
        title: '¡Uy!',
        text: 'Parece que no has copiado el enlace.',
      },
      recipientemailinvalidformat: {
        title: '¡Uy!',
        text: 'Has introducido la dirección de uno de tus amigos incorrectamente.',
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: '¡Ostras!',
        text: 'Uno (o más) de tus archivos tiene un nombre que contiene una barra invertida. No podemos aceptarlo, dale un nuevo nombre sin incluir la barra invertida.',
      },
      title: '¡Vaya!',
      text: "iOS7 no te permite enviar vídeos mediante nuestra web, pero si utilizas nuestra <a href='%{wetransfer_ios_app_store_url}'>fantástica aplicación WeTransfer</a>, ¡sí que puedes!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Consejo',
        text: 'Puedes enviar hasta 2 GB por transferencia. Y lo que es aún mejor: puedes realizar la transferencia tantas veces como quieras.',
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Importante',
        text: "Tu cuenta Pro puede enviar hasta 20 GB por transferencia, pero tu explorador lo impide. <a href='/questions/33'>Haz clic aquí para obtener más información.</a>",
      },
      recipients_tip: {
        title: 'Consejo',
        text: 'Puedes introducir hasta %{email_limit} direcciones de email. Si solo quieres un enlace de descarga, haz clic en el botón que aparece más abajo.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Consejo',
        text: 'Pon tu propia dirección de email aquí para que podamos contactar contigo cuando los archivos se hayan descargado.',
      },
      expire_tip: {
        title: 'Consejo',
        text: 'Ya puedes modificar la fecha de caducidad de tus transferencias Pro.',
      },
      message_tip: {
        title: 'Consejo',
        text: '¿Quieres enviar un mensaje a tus amigos junto con los archivos? Ésta es tu oportunidad, pero no tienes por qué hacerlo.',
      },
      share_tip: {
        title: 'Consejo',
        text: 'Cambia la forma de compartir tus archivos. Envíalos por email o consigue un enlace de descarga.',
        text_plus:
          'Cambia la forma de compartir tus archivos. Envíalos por email, Twitter, Facebook o consigue un enlace de descarga.',
      },
      download: {
        title: '',
        chrome:
          "La descarga funciona de distinta forma que antes. Ahora estamos descargando todos los archivos a través de un navegador, por lo que ya no veras la barra de progreso en WeTransfer y puede que no se te pregunte dónde guardar el archivo. El progreso de la descarga estará visible en la parte inferior de tu navegador y tu archivo se guardará por defecto en tu carpeta de Descargas. <a href='/questions/24' target='_blank'>Averigua como cambiar esto aquí</a>.",
        firefox:
          "La descarga funciona de distinta forma que antes. Ahora estamos descargando todos los archivos a través de un navegador, por lo que ya no verás la barra de progreso en WeTransfer y puede que no se te pregunte dónde guardar el archivo. El progreso estará visible en la ventana de descargas de tu navegador y tu archivo se guardará por defecto en tu carpeta de Descargas. <a href='/questions/24' target='_blank'>Más detalles</a>.",
        safari:
          "La descarga funciona de distinta forma que antes. Ahora estamos descargando todos los archivos a través de un navegador, por lo que ya no verás la barra de progreso en WeTransfer y puede que no se te pregunte dónde guardar el archivo. El progreso de la descarga estará visible en la parte superior derecha de tu navegador y tu archivo se guardará por defecto en tu carpeta de Descargas. <a href='/questions/24' target='_blank'>Más detalles</a>.",
        old_explorer:
          "La descarga funciona de distinta forma que antes. Ahora estamos descargando todos los archivos a través de un navegador, por lo que ya no veras la barra de progreso en WeTransfer y puede que no se te pregunte dónde guardar el archivo. También puede que veas un aviso de seguridad en la parte superior de la ventana del navegador. <a href='/questions/24' target='_blank'>Más detalles</a>.",
        explorer:
          "La descarga funciona de distinta forma que antes. Ahora estamos descargando todos los archivos a través de un navegador, por lo que ya no veras la barra de progreso en WeTransfer y puede que no se te pregunte dónde guardar el archivo. El progreso estará visible en la parte inferior de tu navegador (puede que necesites pulsar en Guardar primero) y tu archivo se guardará por defecto en tu carpeta de Descargas. <a href='/questions/24' target='_blank'>Más detalles</a>.",
        settings:
          'Puedes cambiar la ubicación por defecto para las descargas en los ajustes de tu navegador.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Si reenvías esta transferencia el formulario se quedará en blanco, ¿estás seguro?',
    is_busy: 'Lo sentimos, ahora mismo no podemos hacer eso',
  },
  mobile_app: {
    remember_choice: 'No volver a mostrar este mensaje',
    uploader: {
      description:
        'Nuestro sitio web no está optimizado aún para uso en el móvil. Pero sí tenemos una estupenda aplicación para móvil.',
      app_name: 'WeTransfer',
      download: 'Descargar aplicación',
      continue: 'Continuar en WeTransfer.com',
    },
    downloader: {
      title: 'Sus archivos están listos para la descarga',
      description_ios:
        'Hemos compactado sus archivos en un zip. Necesitará una aplicación para extraerlos y visualizarlos. <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a> nos parece una muy buena opción.',
      description_android:
        'Hemos compactado sus archivos en un zip. Necesitará una aplicación para extraerlos y visualizarlos. <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a> nos parece una muy buena opción.',
      continue: 'Entendido',
    },
  },
};
